(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // refs
    this.header = null;
    this.headerSection = null;
    this.predictiveSearch = null;

    // state
    this.headerBounds = { top: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.isScrolling = null;

    // cached geometry (filled ONLY after user intent)
    this.headerGroupHeight = 0;
    this.headerHeight = 0;
    this.headerBottomAbs = 0;
    this.stickyType = 'disable';

    // raf
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._rafMeasure = 0;
    this._needsMeasure = false;

    // observers (created ONLY after start)
    this.resizeObserver = null;
    this.io = null;

    // flags
    this._started = false;

    // binds
    this._onScrollEvent = this._onScrollEvent.bind(this);
    this._flushScroll = this._flushScroll.bind(this);

    this._scheduleMeasure = this._scheduleMeasure.bind(this);
    this._flushMeasure = this._flushMeasure.bind(this);

    this._onSectionLoad = this._onSectionLoad.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    // wake handlers (NO layout reads)
    this._wake = this._wake.bind(this);
    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);

    this.handleScrollOnce = this.handleScrollOnce.bind(this);
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    window.removeEventListener('scroll', this._onScrollEvent);

    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this.resizeObserver) {
      try { this.resizeObserver.disconnect(); } catch(e) {}
      this.resizeObserver = null;
    }

    if (this.io) {
      try { this.io.disconnect(); } catch(e) {}
      this.io = null;
    }

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    if (this._rafMeasure) cancelAnimationFrame(this._rafMeasure);
    this._rafScroll = 0;
    this._rafMeasure = 0;

    this._started = false;
  }

  _wakeOnScroll() { this._wake('scroll'); }
  _wakeOnPointer() { this._wake('pointer'); }
  _wakeOnKey() { this._wake('key'); }

  _wake(_reason) {
    if (this._started) return;
    this._started = true;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this._start();
  }

  _start() {
    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this.headerSection = this.header.querySelector('.header') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.stickyType = this.headerSection?.dataset?.stickyType || 'disable';

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    this.onScrollHandler = (this.stickyType === 'on_scroll')
      ? this._onScrollLogic.bind(this)
      : this._onAlwaysScrollLogic.bind(this);

    window.addEventListener('scroll', this._onScrollEvent, { passive: true });
    document.addEventListener('shopify:section:load', this._onSectionLoad);
    window.addEventListener('scroll', this.handleScrollOnce, { passive: true });

    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.currentScrollTop = this._pendingScrollTop;

    this._scheduleMeasure();

    if (this.stickyType !== 'disable') {
      this._createIntersectionObserver();
      this._createResizeObserver();
    }

    this.onScrollHandler();
  }


  _onScrollEvent() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._flushScroll);
  }

  _flushScroll() {
    this._rafScroll = 0;
    if (this.onScrollHandler) this.onScrollHandler();
  }

  _scheduleMeasure() {
    this._needsMeasure = true;
    if (this._rafMeasure) return;
    this._rafMeasure = requestAnimationFrame(this._flushMeasure);
  }

  _flushMeasure() {
    this._rafMeasure = 0;
    if (!this._needsMeasure) return;
    this._needsMeasure = false;
    this._setHeaderHeight();
  }

  _setHeaderHeight() {
    if (!this.header || !this.headerSection) return;

    const g1 = this.header.previousElementSibling;
    const g2 = g1 ? g1.previousElementSibling : null;
    const g3 = g2 ? g2.previousElementSibling : null;

    const inner = this.header.querySelector('.header') || this.headerSection;

    let total = inner ? inner.offsetHeight : 0;
    if (g1) total += g1.offsetHeight;
    if (g2) total += g2.offsetHeight;
    if (g3) total += g3.offsetHeight;

    this.headerGroupHeight = total;
    this.headerHeight = this.headerSection.offsetHeight || 0;

    document.documentElement.style.setProperty('--header-height', `${this.headerGroupHeight}px`);
    document.documentElement.style.setProperty(
      '--sticky-header-height',
      this.stickyType === 'disable' ? '0px' : `${this.headerHeight}px`
    );

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const rect = this.headerSection.getBoundingClientRect();
    this.headerBottomAbs = rect.bottom + scrollTop;

    if (!this.headerBounds || typeof this.headerBounds.top !== 'number') {
      this.headerBounds = { top: rect.top + scrollTop };
    }
  }

  _onSectionLoad(event) {
    if (
      event?.target?.closest?.('.shopify-section-header') ||
      event?.target?.closest?.('.shopify-section-announcement-bar')
    ) {
      this._scheduleMeasure();
      this._onScrollEvent();
    }
  }

  _createResizeObserver() {
    if (this.resizeObserver || !this.headerSection) return;
    this.resizeObserver = new ResizeObserver(() => {
      this._scheduleMeasure();
    });
    this.resizeObserver.observe(this.headerSection);
  }

  _createIntersectionObserver() {
    if (this.io || !this.headerSection) return;

    this.io = new IntersectionObserver((entries, observer) => {
      const e = entries && entries[0];
      if (e && e.intersectionRect) this.headerBounds = e.intersectionRect;
      else this.headerBounds = { top: 0 };
      observer.disconnect();
      this.io = null;
    });

    this.io.observe(this.headerSection);
  }

  handleScrollOnce() {
    const shopifySection = this.header;
    if (!shopifySection) {
      window.removeEventListener('scroll', this.handleScrollOnce);
      return;
    }

    const cls = shopifySection.className || '';
    const w = window.innerWidth;

    const overlapEnabled =
      cls.includes('overlap-enable') ||
      (cls.includes('overlap-desktop') && w > 1024) ||
      (cls.includes('overlap-mobile') && w < 1025);

    if (overlapEnabled) {
      const st = window.scrollY || document.documentElement.scrollTop || 0;
      if (st > 5) shopifySection.classList.add('animate');
    }

    window.removeEventListener('scroll', this.handleScrollOnce);
  }


  disableTransitionForMs(ms) {
    if (!this.header) return;
    this.header.classList.add('transition-none');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('transition-none');
    }, ms);
  }

  _onScrollLogic() {
    if (!this.header || !this.headerSection) return;

    if (document.body.classList.contains('disable-scroll') ||
        document.body.classList.contains('disable-scroll-body')) return;
    if (document.body.classList.contains('after-focusout')) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop <= 0) {
      this.reset();
      this.currentScrollTop = 0;
      return;
    }

    if (this.querySelector('details-dropdown[open]')) {
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.disableTransitionForMs(300);
      }

      if (scrollTop >= (this.headerBounds?.top || 0)) {
        this.header.classList.remove('shopify-section-header-sticky', 'animate', 'disable-visibility');
      }

      const delta = scrollTop - (this.currentScrollTop ?? 0);
      if (delta < 0) this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.currentScrollTop = scrollTop;
      return;
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    const headerBottom = this.headerBottomAbs || (this.headerHeight ? (this.headerHeight + 1) : 0);

    if (scrollTop > this.currentScrollTop + 3 && scrollTop > (this.headerGroupHeight || 0)) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
      if (!this.preventReveal) {
        this.reveal();
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this.hide();
      }
    } else if (scrollTop <= (this.headerBounds?.top || 0)) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  _onAlwaysScrollLogic() {
    if (!this.header) return;

    const scrollTop = this._pendingScrollTop;

    if (scrollTop > 5) this.header.classList.add('animate');
    if (
      scrollTop < 5 &&
      !document.body.classList.contains('disable-scroll') &&
      !document.body.classList.contains('disable-scroll-body') &&
      !document.body.classList.contains('after-focusout')
    ) {
      this.header.classList.remove('animate');
    }
  }

  hide() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'disable-visibility');
    setTimeout(() => {
      if (this.header) this.header.classList.remove('disable-visibility');
    }, 100);
  }

  reveal() {
    if (!this.header) return;

    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.disableTransitionForMs(300);
    }

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden', 'disable-visibility');
  }

  reset() {
    if (!this.header) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
      'transition-none',
      'disable-visibility'
    );
  }
}

customElements.define('sticky-header', StickyHeader);

  class SearchElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        if(!this.querySelector('.search-field__text')) return
        this.querySelector('.search-field__text').addEventListener('focus', () => {
            const scrollY = window.scrollY || window.pageYOffset;
            document.body.dataset.scrollY = scrollY;
            document.body.style.top = `-${scrollY}px`;
            document.body.classList.add('disable-scroll-body')
        })
        this.querySelector('.search-field__text').addEventListener('focusout', () => {
            this.querySelector('.search-field__text').value = ''
            if (document.body.classList.contains('disable-scroll-body')) {
                document.body.classList.add('after-focusout')
                document.documentElement.style.scrollBehavior = 'auto'
                const scrollY = parseInt(document.body.dataset.scrollY || '0', 10);
                document.body.classList.remove('disable-scroll-body')
                document.body.style.top = '';
                window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
            }
            setTimeout(() => {document.documentElement.style.scrollBehavior = 'smooth'},10)
            setTimeout(() => document.body.classList.remove('after-focusout'), 200)
        })
    }

  }
  customElements.define('search-element', SearchElement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-about-intro"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const wrap = event.target.closest('.js-about-intro-cta');
    if (!wrap) return;
    const link = wrap.tagName === 'A' ? wrap : wrap.querySelector('a');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    const id = href.slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-about-story"] && !Shopify.designMode) return;
  try {
    
  function saAboutStoryIsDesktop() {
    return window.innerWidth >= 1000;
  }

  function saAboutStoryTickStep() {
    if (window.innerWidth < 1000) {
      return Math.round(Math.min(160, Math.max(48, window.innerHeight * 0.08)));
    }
    return Math.round(Math.min(240, Math.max(96, window.innerWidth * 0.14)));
  }

  function syncSaAboutStory(root, swiper, index) {
    if (!root) return;
    const total = root.querySelectorAll('[data-about-story-slide]').length;
    const slideIndex = typeof index === 'number' ? index : 0;
    let progress = total > 1 ? slideIndex / (total - 1) : 0;
    if (swiper && typeof swiper.progress === 'number') {
      progress = Math.max(0, Math.min(1, swiper.progress));
    }
    root.style.setProperty(
      '--about-story-ruler-shift',
      String(progress * saAboutStoryTickStep() * Math.max(0, total - 1))
    );
    root.style.setProperty('--about-story-year-index', String(slideIndex));
    const yearLabels = root.querySelectorAll('[data-about-story-year-label]');
    const yearLabel = yearLabels[slideIndex];
    const markerX = yearLabel ? Math.round(yearLabel.getBoundingClientRect().width / 2) : 0;
    root.style.setProperty('--about-story-marker-x', markerX + 'px');
  }

  function syncSaAboutStoryFromScroll(root) {
    const slides = Array.from(root.querySelectorAll('[data-about-story-slide]'));
    const total = slides.length;
    if (!total) return;
    const mid = window.innerHeight * 0.35;
    let index = 0;
    let best = Infinity;
    slides.forEach(function (slide, i) {
      const dist = Math.abs(slide.getBoundingClientRect().top - mid);
      if (dist < best) {
        best = dist;
        index = i;
      }
    });
    const rect = root.getBoundingClientRect();
    const travel = Math.max(1, rect.height - window.innerHeight);
    const progress = Math.max(0, Math.min(1, -rect.top / travel));
    syncSaAboutStory(root, { progress: progress }, index);
  }

  function closeSaAboutStoryDialog(root) {
    const dialog = root.querySelector('[data-about-story-dialog]');
    if (!dialog || !dialog.open) return;
    dialog.close();
    root.dataset.dialogOpen = 'false';
    const swiper = root._saAboutStorySwiper;
    if (swiper) swiper.allowTouchMove = true;
  }

  function openSaAboutStoryDialog(root, awardId) {
    const dialog = root.querySelector('[data-about-story-dialog]');
    if (!dialog) return;
    Array.from(root.querySelectorAll('[data-award-panel]')).forEach(function (panel) {
      const on = panel.getAttribute('data-award-panel') === String(awardId);
      panel.hidden = !on;
    });
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    root.dataset.dialogOpen = 'true';
    const swiper = root._saAboutStorySwiper;
    if (swiper) swiper.allowTouchMove = false;
  }

  function alignSaAboutStory(root) {
    const top = root.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'auto' });
  }

  function bindSaAboutStoryAwards(root) {
    if (root.dataset.aboutStoryAwardsBound === 'true') return;
    root.dataset.aboutStoryAwardsBound = 'true';

    Array.from(root.querySelectorAll('[data-about-story-award]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        openSaAboutStoryDialog(root, btn.getAttribute('data-award-id'));
      });
    });

    const dialog = root.querySelector('[data-about-story-dialog]');
    const closeBtn = root.querySelector('[data-about-story-dialog-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeSaAboutStoryDialog(root);
      });
    }
    if (dialog) {
      dialog.addEventListener('close', function () {
        root.dataset.dialogOpen = 'false';
        if (root._saAboutStorySwiper) root._saAboutStorySwiper.allowTouchMove = true;
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeSaAboutStoryDialog(root);
      });
    }
  }

  function teardownSaAboutStory(root) {
    if (root._saAboutStoryOnWheel) {
      window.removeEventListener('wheel', root._saAboutStoryOnWheel);
      root._saAboutStoryOnWheel = null;
    }
    if (root._saAboutStoryOnScroll) {
      window.removeEventListener('scroll', root._saAboutStoryOnScroll);
      root._saAboutStoryOnScroll = null;
    }
    if (root._saAboutStoryOnResize) {
      window.removeEventListener('resize', root._saAboutStoryOnResize);
      root._saAboutStoryOnResize = null;
    }
    if (root._saAboutStorySwiper) {
      root._saAboutStorySwiper.destroy(true, true);
      root._saAboutStorySwiper = null;
    }
    root.dataset.aboutStoryReady = 'false';
    root.dataset.aboutStoryMode = '';
  }

  function initSaAboutStoryMobile(root) {
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncSaAboutStoryFromScroll(root);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    root._saAboutStoryOnScroll = onScroll;
    syncSaAboutStoryFromScroll(root);
  }

  function initSaAboutStoryDesktop(root) {
    if (typeof Swiper === 'undefined') return;
    const swiperEl = root.querySelector('[data-about-story-swiper]');
    if (!swiperEl) return;
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const slideCount = root.querySelectorAll('[data-about-story-slide]').length;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let animating = false;
    let index = 0;

    const swiper = new Swiper(swiperEl, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      speed: reduceMotion ? 0 : 850,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      resistanceRatio: 0.15,
      allowTouchMove: slideCount > 1,
      touchReleaseOnEdges: true,
      nested: false,
      observer: true,
      observeParents: true,
      on: {
        init: function (instance) {
          index = instance.activeIndex;
          syncSaAboutStory(root, instance, index);
        },
        slideChange: function (instance) {
          index = instance.activeIndex;
          syncSaAboutStory(root, instance, index);
        },
        progress: function (instance) {
          syncSaAboutStory(root, instance, instance.activeIndex);
        },
        setTransition: function (instance, duration) {
          root.querySelectorAll('[data-about-story-ticks]').forEach(function (ticks) {
            ticks.style.transitionDuration = (reduceMotion ? 0 : duration) + 'ms';
          });
        },
        slideChangeTransitionStart: function () {
          animating = true;
        },
        slideChangeTransitionEnd: function () {
          animating = false;
        },
      },
    });

    root._saAboutStorySwiper = swiper;

    function go(next) {
      if (next < 0 || next > slideCount - 1 || next === index) return false;
      animating = true;
      swiper.slideTo(next);
      return true;
    }

    function onWheel(event) {
      if (!saAboutStoryIsDesktop()) return;
      if (root.dataset.dialogOpen === 'true') {
        event.preventDefault();
        return;
      }
      if (slideCount < 2) return;

      const dy = event.deltaY;
      if (Math.abs(dy) < 10) return;

      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight;
      const inside = rect.top <= 2 && rect.bottom >= vh - 2;
      const enteringDown = dy > 0 && rect.top < vh * 0.72 && rect.top > 2;
      const enteringUp = dy < 0 && rect.bottom > vh * 0.28 && rect.bottom < vh - 2;

      if (enteringDown) {
        event.preventDefault();
        if (animating) return;
        animating = true;
        alignSaAboutStory(root);
        go(0);
        window.setTimeout(function () {
          animating = false;
        }, 400);
        return;
      }

      if (enteringUp) {
        event.preventDefault();
        if (animating) return;
        animating = true;
        alignSaAboutStory(root);
        go(slideCount - 1);
        window.setTimeout(function () {
          animating = false;
        }, 400);
        return;
      }

      if (!inside) return;

      if (animating) {
        event.preventDefault();
        return;
      }

      if (dy > 0 && index < slideCount - 1) {
        event.preventDefault();
        alignSaAboutStory(root);
        go(index + 1);
      } else if (dy < 0 && index > 0) {
        event.preventDefault();
        alignSaAboutStory(root);
        go(index - 1);
      }
    }

    window.addEventListener('wheel', onWheel, { passive: false });
    root._saAboutStoryOnWheel = onWheel;
  }

  function initSaAboutStory(root) {
    if (!root) return;
    const mode = saAboutStoryIsDesktop() ? 'desktop' : 'mobile';
    if (root.dataset.aboutStoryMode === mode && root.dataset.aboutStoryReady === 'true') return;
    if (mode === 'desktop' && typeof Swiper === 'undefined') return;

    teardownSaAboutStory(root);
    bindSaAboutStoryAwards(root);
    root.dataset.aboutStoryMode = mode;
    root.dataset.aboutStoryReady = 'true';

    if (mode === 'desktop') initSaAboutStoryDesktop(root);
    else initSaAboutStoryMobile(root);

    function onResize() {
      const next = saAboutStoryIsDesktop() ? 'desktop' : 'mobile';
      if (root.dataset.aboutStoryMode !== next) {
        root.dataset.aboutStoryReady = 'false';
        initSaAboutStory(root);
        return;
      }
      if (next === 'desktop' && root._saAboutStorySwiper) {
        root._saAboutStorySwiper.update();
        syncSaAboutStory(root, root._saAboutStorySwiper, root._saAboutStorySwiper.activeIndex);
      } else {
        syncSaAboutStoryFromScroll(root);
      }
    }
    window.addEventListener('resize', onResize);
    root._saAboutStoryOnResize = onResize;
  }

  function initSaAboutStories(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-about-story')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-about-story'));
    sections.forEach(initSaAboutStory);
  }

  function whenSaAboutStorySwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
        callback();
      }
    }, 50);
  }

  function bootSaAboutStory() {
    if (saAboutStoryIsDesktop()) {
      whenSaAboutStorySwiperReady(function () {
        initSaAboutStories();
      });
      return;
    }
    initSaAboutStories();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaAboutStory);
  } else {
    bootSaAboutStory();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target.querySelector('.sa-about-story') || event.target.closest('.sa-about-story');
    if (!root) return;
    teardownSaAboutStory(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (saAboutStoryIsDesktop()) {
      whenSaAboutStorySwiperReady(function () {
        initSaAboutStories(event.target);
      });
      return;
    }
    initSaAboutStories(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-about-story');
    if (!root) return;
    const award = event.target.closest('[data-about-story-award]');
    const slide = event.target.closest('.swiper-slide');
    if (award) {
      const slides = Array.from(root.querySelectorAll('[data-about-story-slide]'));
      const awardsSlide = slides.find(function (el) {
        return el.getAttribute('data-slide-type') === 'awards';
      });
      if (awardsSlide) {
        if (root._saAboutStorySwiper) {
          root._saAboutStorySwiper.slideTo(slides.indexOf(awardsSlide));
        } else {
          awardsSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      openSaAboutStoryDialog(root, award.getAttribute('data-award-id'));
      return;
    }
    closeSaAboutStoryDialog(root);
    if (slide) {
      if (root._saAboutStorySwiper) {
        const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
        const index = slides.indexOf(slide);
        if (index >= 0) root._saAboutStorySwiper.slideTo(index);
      } else {
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnouncement(root) {
      const bar = root.matches?.('[data-sa-announcement]')
        ? root
        : root.querySelector('[data-sa-announcement]');
      if (!bar) return;
      const items = Array.from(bar.querySelectorAll('[data-sa-announcement-item]'));
      if (items.length < 2) return;
      if (bar.dataset.rotate === 'false') return;

      const speed = parseInt(bar.dataset.speed, 10) || 5000;
      let index = items.findIndex((el) => el.classList.contains('is-active'));
      if (index < 0) index = 0;

      if (bar._saTimer) clearInterval(bar._saTimer);
      bar._saTimer = setInterval(() => {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, speed);
    }

    const start = (root) => initAnnouncement(root || document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document));
    } else {
      start(document);
    }

    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-campaign-discount"] && !Shopify.designMode) return;
  try {
    
  function initSaCampaignDiscount(root) {
    if (!root || root.dataset.copyReady === 'true') return;
    root.dataset.copyReady = 'true';

    root.addEventListener('click', function (event) {
      const pill = event.target.closest('[data-discount-code]');
      if (!pill || !root.contains(pill)) return;
      const code = pill.getAttribute('data-discount-code');
      if (!code) return;

      copySaCampaignCode(code)
        .then(function () {
          showSaCampaignCopied(root, pill);
        })
        .catch(function () {});
    });
  }

  function copySaCampaignCode(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        input.remove();
      }
    });
  }

  function setSaCampaignToast(toast, visible) {
    if (!toast) return;
    toast.classList.toggle('hidden', !visible);
    toast.classList.toggle('inline-flex', visible);
  }

  function showSaCampaignCopied(root, pill) {
    root.querySelectorAll('.sa-campaign-discount__pill.is-copied').forEach(function (item) {
      if (item === pill) return;
      item.classList.remove('is-copied');
      setSaCampaignToast(item.querySelector('[data-copied]'), false);
    });

    pill.classList.add('is-copied');
    const toast = pill.querySelector('[data-copied]');
    setSaCampaignToast(toast, true);

    let live = root.querySelector('[data-copy-live]');
    if (!live) {
      live = document.createElement('span');
      live.className = 'sr-only';
      live.setAttribute('data-copy-live', '');
      live.setAttribute('aria-live', 'polite');
      root.appendChild(live);
    }
    live.textContent = toast ? toast.textContent.trim() : '';

    window.clearTimeout(root._saCopyTimer);
    root._saCopyTimer = window.setTimeout(function () {
      pill.classList.remove('is-copied');
      setSaCampaignToast(toast, false);
    }, 2000);
  }

  function initSaCampaignDiscountSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-campaign-discount')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-campaign-discount'));
    sections.forEach(initSaCampaignDiscount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaCampaignDiscountSections();
    });
  } else {
    initSaCampaignDiscountSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaCampaignDiscountSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-category-strip"] && !Shopify.designMode) return;
  try {
    
  function initSaCategoryStrip(root) {
    if (!root || root.dataset.stripReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = root.querySelector('[data-sa-category-strip-swiper]');
    if (!swiperEl || swiperEl.swiper) {
      if (swiperEl && swiperEl.swiper) root.dataset.stripReady = 'true';
      return;
    }

    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount === 0) return;

    const swiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 'auto',
      spaceBetween: 4,
      grabCursor: slideCount > 1,
      watchOverflow: true,
      allowTouchMove: slideCount > 1,
      speed: 400,
      breakpoints: {
        1000: {
          slidesPerView: 'auto',
          spaceBetween: 8,
        },
      },
    });

    root._saCategoryStripSwiper = swiper;
    root.dataset.stripReady = 'true';

    requestAnimationFrame(function () {
      if (swiper && !swiper.destroyed) swiper.update();
    });
  }

  function initSaCategoryStripSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-category-strip')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-category-strip'));
    sections.forEach(initSaCategoryStrip);
  }

  function whenSaCategoryStripSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaCategoryStrip() {
    whenSaCategoryStripSwiperReady(function () {
      initSaCategoryStripSections();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaCategoryStrip);
  } else {
    bootSaCategoryStrip();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSaCategoryStripSwiperReady(function () {
      initSaCategoryStripSections(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-category-strip');
    if (!root || !root._saCategoryStripSwiper) return;
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const index = slides.indexOf(slide);
    if (index >= 0) root._saCategoryStripSwiper.slideTo(index);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-china-stores"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function compact(value) {
      return normalize(value).replace(/\s+/g, '');
    }

    function matchesQuery(card, query) {
      if (!query) return true;
      var hay = card.getAttribute('data-search') || '';
      return hay.indexOf(query) !== -1 || compact(hay).indexOf(compact(query)) !== -1;
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.left = '-9999px';
        document.body.appendChild(area);
        area.select();
        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        } finally {
          document.body.removeChild(area);
        }
      });
    }

    function bind(root) {
      if (!root || root.dataset.chinaBound === 'true') return;
      root.dataset.chinaBound = 'true';

      var form = root.querySelector('[data-china-form]');
      var input = root.querySelector('[data-china-search]');
      var region = root.querySelector('[data-china-region]');
      var regionLabel = root.querySelector('[data-china-region-label]');
      var list = root.querySelector('[data-china-list]');
      var empty = root.querySelector('[data-china-empty]');
      var more = root.querySelector('[data-china-more]');
      var pageSize = parseInt(root.dataset.pageSize, 10) || 3;
      var copiedLabel = root.dataset.copiedLabel || 'Copied';
      var shown = pageSize;

      function cards() {
        return list ? Array.prototype.slice.call(list.querySelectorAll('[data-china-store]')) : [];
      }

      function apply() {
        var query = normalize(input ? input.value : '');
        var province = region ? region.value : '';
        var matched = cards().filter(function (card) {
          var cardProvince = card.getAttribute('data-province') || '';
          var provinceOk = !province || cardProvince === province;
          return provinceOk && matchesQuery(card, query);
        });

        cards().forEach(function (card) {
          card.hidden = true;
        });
        matched.forEach(function (card, index) {
          card.hidden = index >= shown;
        });

        if (empty) empty.hidden = matched.length !== 0;
        if (more) more.hidden = matched.length <= shown;
      }

      var regionToggle = root.querySelector('[data-china-region-toggle]');
      var regionMenu = root.querySelector('[data-china-region-menu]');
      var regionOptions = regionMenu ? regionMenu.querySelectorAll('[data-china-region-option]') : [];

      function syncRegionLabel() {
        if (!region || !regionLabel) return;
        var option = region.options[region.selectedIndex];
        var value = region.value || '';
        regionLabel.textContent = option ? option.textContent : '';
        Array.prototype.forEach.call(regionOptions, function (item) {
          var selected = (item.getAttribute('data-value') || '') === value;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      }

      function setRegionOpen(open) {
        if (!regionMenu || !regionToggle) return;
        regionMenu.hidden = !open;
        regionToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        root.classList.toggle('is-region-open', open);
      }

      function resetAndApply() {
        shown = pageSize;
        apply();
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          resetAndApply();
        });
      }
      if (input) input.addEventListener('input', resetAndApply);
      if (region) {
        region.addEventListener('change', function () {
          syncRegionLabel();
          resetAndApply();
        });
      }
      if (regionToggle) {
        regionToggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setRegionOpen(regionMenu.hidden);
        });
      }
      Array.prototype.forEach.call(regionOptions, function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!region) return;
          region.value = item.getAttribute('data-value') || '';
          region.dispatchEvent(new Event('change', { bubbles: true }));
          setRegionOpen(false);
        });
      });
      syncRegionLabel();
      if (more) {
        more.addEventListener('click', function () {
          shown = cards().length;
          apply();
        });
      }

      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-china-copy]');
        if (!button || !root.contains(button)) return;
        var text = button.getAttribute('data-copy-text') || '';
        var label = button.querySelector('[data-copy-label]');
        if (!text || !label) return;
        var original = label.textContent;
        copyText(text).then(function () {
          label.textContent = copiedLabel;
          window.setTimeout(function () {
            label.textContent = original;
          }, 1600);
        });
      });

      apply();
    }

    function closeRegionMenus(except) {
      document.querySelectorAll('[data-china-region-menu]').forEach(function (menu) {
        if (except && menu === except) return;
        menu.hidden = true;
        var wrap = menu.closest('[data-china-region-wrap]');
        var toggle = wrap && wrap.querySelector('[data-china-region-toggle]');
        var section = menu.closest('[data-sa-china-stores]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (section) section.classList.remove('is-region-open');
      });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-china-region-wrap]')) return;
      closeRegionMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeRegionMenus();
    });

    function closeRegionMenusOnMove(event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-china-region-menu]')) return;
      closeRegionMenus();
    }

    window.addEventListener('scroll', closeRegionMenusOnMove, true);
    window.addEventListener('wheel', closeRegionMenusOnMove, { passive: true });
    window.addEventListener('touchmove', closeRegionMenusOnMove, { passive: true });
    window.addEventListener('resize', function () {
      closeRegionMenus();
    });

    function boot(scope) {
      (scope || document).querySelectorAll('[data-sa-china-stores]').forEach(bind);
    }

    boot();

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-sa-china-stores]');
      if (!root) return;
      delete root.dataset.chinaBound;
      bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindReadMore(root) {
      const wrap = root.matches?.('[data-sa-read-more]')
        ? root
        : root.querySelector('[data-sa-read-more]');
      if (!wrap || wrap.dataset.saReadMoreReady === 'true') return;

      const body = wrap.querySelector('[data-sa-read-more-body]');
      const toggle = wrap.querySelector('[data-sa-read-more-toggle]');
      if (!body || !toggle) return;

      wrap.dataset.saReadMoreReady = 'true';

      toggle.addEventListener('click', function () {
        const expanded = body.classList.toggle('is-collapsed') === false;
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const moreLabel = toggle.querySelector('[data-sa-read-more-more]');
        const lessLabel = toggle.querySelector('[data-sa-read-more-less]');
        if (moreLabel) moreLabel.hidden = expanded;
        if (lessLabel) lessLabel.hidden = !expanded;
      });
    }

    const start = (root) => bindReadMore(root || document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(document));
    } else {
      start(document);
    }

    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sa-collection')) {
    customElements.define(
      'sa-collection',
      class SaCollection extends HTMLElement {
        connectedCallback() {
          if (this._bound) return;
          this._bound = true;
          this.compareItems = [];
          this._onClick = this.onClick.bind(this);
          this._onChange = this.onChange.bind(this);
          this._onInput = this.onInput.bind(this);
          this._onPop = this.onPop.bind(this);
          this._onKey = this.onKey.bind(this);
          this._onProductAdded = this.onProductAdded.bind(this);
          this.addEventListener('click', this._onClick);
          this.addEventListener('change', this._onChange);
          this.addEventListener('input', this._onInput);
          window.addEventListener('popstate', this._onPop);
          document.addEventListener('keydown', this._onKey);
          document.addEventListener('ajaxProduct:added', this._onProductAdded);
          this._onModalClick = (event) => {
            if (event.target === this.compareModal) this.closeCompareModal();
          };
          const modal = this.compareModal;
          if (modal) modal.addEventListener('click', this._onModalClick);
          this.restoreOpen();
          this.initPrice();
          this.syncCompareUI();
          this._syncToolbarOffset = this.syncToolbarOffset.bind(this);
          this._syncToolbarOffset();
          const toolbar = this.querySelector('[data-sa-collection-toolbar]');
          if (toolbar && typeof ResizeObserver !== 'undefined') {
            this._toolbarObserver = new ResizeObserver(this._syncToolbarOffset);
            this._toolbarObserver.observe(toolbar);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          this.removeEventListener('change', this._onChange);
          this.removeEventListener('input', this._onInput);
          window.removeEventListener('popstate', this._onPop);
          document.removeEventListener('keydown', this._onKey);
          document.removeEventListener('ajaxProduct:added', this._onProductAdded);
          this.compareModal?.removeEventListener('click', this._onModalClick);
           this._toolbarObserver?.disconnect();
          document.documentElement.classList.remove('sa-collection-lock');
          document.body.classList.remove('filter-drawer-opened');
          document.body.style.overflow = '';
          this._bound = false;
        }

        get isMobile() {
          return window.matchMedia('(max-width: 999px)').matches;
        }
        syncToolbarOffset() {
          const toolbar = this.querySelector('[data-sa-collection-toolbar]');
          if (!toolbar) return;
          this.style.setProperty('--sa-collection-toolbar-height', `${Math.ceil(toolbar.getBoundingClientRect().height)}px`);
        }
        restoreOpen() {
          if (this.isMobile) {
            this.setOpen(false, false);
            return;
          }
          let open = this.dataset.filtersOpen === 'true';
          try {
            const stored = sessionStorage.getItem('sa-collection-filters-open');
            if (stored === '1') open = true;
            if (stored === '0') open = false;
          } catch (error) {}
          this.setOpen(open, false);
        }

        setOpen(open, persist) {
          this.classList.toggle('is-filters-open', open);
          this.classList.toggle('is-mobile-filters-open', open && this.isMobile);
          const toggle = this.querySelector('[data-sa-filters-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          const overlay = this.querySelector('[data-sa-filters-overlay]');
          if (overlay) overlay.hidden = !(open && this.isMobile);
          const sidebar = this.querySelector('[data-sa-filters-sidebar]');
          if (sidebar) {
            if (open) sidebar.removeAttribute('inert');
            else if (this.isMobile) sidebar.setAttribute('inert', '');
            else sidebar.removeAttribute('inert');
          }
          document.documentElement.classList.toggle('sa-collection-lock', open && this.isMobile);
          document.body.classList.toggle('filter-drawer-opened', open && this.isMobile);
          document.body.style.overflow = open && this.isMobile ? 'hidden' : '';
          if (persist !== false && !this.isMobile) {
            try {
              sessionStorage.setItem('sa-collection-filters-open', open ? '1' : '0');
            } catch (error) {}
          }
        }

        onProductAdded() {
          if (this.compareModal?.open) this.closeCompareModal();
        }

        onKey(event) {
          if (event.key !== 'Escape') return;
          if (document.body.classList.contains('overlay-opened')) return;
          const modal = this.compareModal;
          if (modal && modal.open) {
            this.closeCompareModal();
            return;
          }
          if (this.classList.contains('is-compare')) {
            this.exitCompare();
            return;
          }
          if (this.classList.contains('is-filters-open') && this.isMobile) {
            this.setOpen(false);
          }
        }

        onClick(event) {
          if (this.handleCompareClick(event)) return;
          if (event.target.closest('[data-sa-filters-toggle]')) {
            this.setOpen(!this.classList.contains('is-filters-open'));
            return;
          }
          if (event.target.closest('[data-sa-filters-close], [data-sa-filters-overlay]')) {
            this.setOpen(false);
            return;
          }
          const reset = event.target.closest('[data-sa-filters-reset]');
          if (reset) {
            event.preventDefault();
            this.render(reset.getAttribute('href'), true);
            return;
          }
          const page = event.target.closest('[data-sa-page-link]');
          if (page) {
            event.preventDefault();
            this.render(page.getAttribute('href'), true);
          }
        }

        get comparePanel() {
          return this.querySelector('[data-sa-compare-panel]');
        }

        get compareModal() {
          return this.querySelector('[data-sa-compare-modal]');
        }

        get compareMax() {
          const panel = this.comparePanel;
          return Number(panel && panel.dataset.max) || 3;
        }

        get compareData() {
          return document.querySelector('sa-compare-data');
        }

        readCompareData(card) {
          if (!card || card.dataset.saCompareId == null) return null;
          const title = card.querySelector('[data-sa-card-title]');
          const image = card.querySelector('.sa-product-card__media');
          return {
            id: card.dataset.saCompareId,
            title: (title?.textContent || '').trim(),
            image: image?.currentSrc || image?.getAttribute('src') || '',
          };
        }

        handleCompareClick(event) {
          const enter = event.target.closest('[data-sa-compare-enter]');
          if (enter) {
  event.preventDefault();
  if (this.classList.contains('is-compare')) {
    this.exitCompare();
  } else {
    this.enterCompare();
  }
  return true;
}

          const cardToggle = event.target.closest('[data-sa-card-compare], [data-sa-compare-select]');
          if (cardToggle) {
            event.preventDefault();
            const data = this.readCompareData(cardToggle.closest('sa-catalog-card'));
            if (data) this.toggleCompare(data);
            return true;
          }

          const remove = event.target.closest('[data-sa-compare-remove]');
          if (remove) {
            event.preventDefault();
            this.removeCompare(remove.closest('[data-id]')?.dataset.id);
            return true;
          }

          if (event.target.closest('[data-sa-compare-toggle]')) {
            event.preventDefault();
            this.toggleComparePanel();
            return true;
          }

          if (event.target.closest('[data-sa-compare-collapse]')) {
            event.preventDefault();
            this.collapseComparePanel();
            return true;
          }

          if (event.target.closest('[data-sa-compare-open]')) {
            event.preventDefault();
            this.openCompareModal();
            return true;
          }

          if (event.target.closest('[data-sa-compare-clear]')) {
            event.preventDefault();
            this.clearCompare();
            return true;
          }

          if (event.target.closest('[data-sa-compare-cancel]')) {
            event.preventDefault();
            this.exitCompare();
            return true;
          }

          if (event.target.closest('[data-sa-compare-close]')) {
            event.preventDefault();
            this.closeCompareModal();
            return true;
          }

          return false;
        }

        enterCompare() {
          this.classList.add('is-compare');
          this.loadCompareCatalog();
          this.syncCompareUI();
        }

        exitCompare() {
          this.compareItems = [];
          this.classList.remove('is-compare');
          this.closeCompareModal();
          this.syncCompareUI();
        }

        toggleCompare(data) {
          if (!data || data.id == null) return;
          this.classList.add('is-compare');
          const id = String(data.id);
          const index = this.compareItems.findIndex((item) => String(item.id) === id);
          if (index >= 0) {
            this.compareItems.splice(index, 1);
          } else if (this.compareItems.length < this.compareMax) {
            this.compareItems.push(data);
          }
          this.syncCompareUI();
        }

        removeCompare(id) {
          if (id == null) return;
          this.compareItems = this.compareItems.filter((item) => String(item.id) !== String(id));
          this.syncCompareUI();
        }

        clearCompare() {
          this.compareItems = [];
          this.syncCompareUI();
        }

        toggleComparePanel() {
          const panel = this.comparePanel;
          if (!panel || panel.hidden) return;
          if (panel.hasAttribute('data-open')) this.collapseComparePanel();
          else this.expandComparePanel();
        }

        expandComparePanel() {
          const panel = this.comparePanel;
          if (!panel) return;
          panel.setAttribute('data-open', '');
          const toggle = panel.querySelector('[data-sa-compare-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
            toggle.setAttribute('aria-label', toggle.dataset.collapseLabel || toggle.getAttribute('aria-label') || '');
          }
        }

        collapseComparePanel() {
          const panel = this.comparePanel;
          if (!panel) return;
          panel.removeAttribute('data-open');
          const toggle = panel.querySelector('[data-sa-compare-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', toggle.dataset.expandLabel || toggle.getAttribute('aria-label') || '');
          }
        }

        syncCompareUI() {
          const active = this.classList.contains('is-compare');
          const selected = new Set(this.compareItems.map((item) => String(item.id)));

          this.querySelectorAll('sa-catalog-card[data-sa-compare-id]').forEach((card) => {
            const button = card.querySelector('[data-sa-compare-select]');
            if (!button) return;
            const on = selected.has(String(card.dataset.saCompareId));
            button.classList.toggle('is-selected', on);
            button.setAttribute('aria-pressed', on ? 'true' : 'false');
            button.disabled = !on && this.compareItems.length >= this.compareMax;
          });

          const panel = this.comparePanel;
          if (panel) {
            const show = active && this.compareItems.length > 0;
            panel.hidden = !show;
            if (!show) this.collapseComparePanel();
          }

          const itemsRoot = panel && panel.querySelector('[data-sa-compare-items]');
          const template = this.querySelector('[data-sa-compare-item-template]');
          if (itemsRoot && template) {
            itemsRoot.replaceChildren();
            this.compareItems.forEach((item) => {
              const node = template.content.firstElementChild.cloneNode(true);
              node.dataset.id = item.id;
              const img = node.querySelector('img');
              if (img) {
                img.src = item.image || '';
                img.alt = item.title || '';
                img.width = 96;
                img.height = 96;
              }
              const name = node.querySelector('[data-sa-compare-name]');
              if (name) name.textContent = item.title || '';
              const remove = node.querySelector('[data-sa-compare-remove]');
              if (remove) remove.setAttribute('aria-label', `${remove.getAttribute('aria-label')} ${item.title || ''}`.trim());
              itemsRoot.appendChild(node);
            });
          }

          const openBtn = panel && panel.querySelector('[data-sa-compare-open]');
          if (openBtn) openBtn.disabled = this.compareItems.length < 2;

          if (this.compareModal && this.compareModal.open) {
            if (this.compareItems.length < 2) this.closeCompareModal();
            else this.renderCompareModal();
          }
        }

        openCompareModal() {
          if (this.compareItems.length < 2) return;
          const modal = this.compareModal;
          if (!modal) return;
          this.showCompareLoading();
          if (typeof modal.showModal === 'function') modal.showModal();
          else modal.setAttribute('open', '');
          this.renderCompareModal();
        }

        closeCompareModal() {
          const modal = this.compareModal;
          if (!modal) return;
          if (typeof modal.close === 'function' && modal.open) modal.close();
          else modal.removeAttribute('open');
        }

        showCompareLoading() {
          const body = this.compareModal && this.compareModal.querySelector('[data-sa-compare-modal-body]');
          const content = body && body.querySelector('[data-sa-compare-content]');
          if (!body) return;
          body.setAttribute('aria-busy', 'true');
          if (content) content.replaceChildren();
        }

        renderCompareModal() {
          const compareData = this.compareData;
          const body = this.compareModal && this.compareModal.querySelector('[data-sa-compare-modal-body]');
          const content = body && body.querySelector('[data-sa-compare-content]');
          if (!compareData || !body || this.compareItems.length < 2) return;

          this.showCompareLoading();
          this._compareRenderId = (this._compareRenderId || 0) + 1;
          const renderId = this._compareRenderId;

          Promise.all([
            compareData.load(this.compareItems.map((item) => item.id)),
            this.loadCompareCatalog(),
          ])
            .then(() => {
              if (renderId !== this._compareRenderId) return;
              const stack = compareData.querySelector('[data-sa-compare-stack]');
              if (stack && content) content.replaceChildren(stack);
              this.fillCompareSelects();
              this.bindCompareScroll();
            })
            .catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            })
            .finally(() => {
              if (renderId !== this._compareRenderId) return;
              body.removeAttribute('aria-busy');
            });
        }

        bindCompareScroll() {
          const stack = this.compareModal && this.compareModal.querySelector('[data-sa-compare-stack]');
          const table = stack && stack.querySelector('[data-sa-compare-table]');
          const atc = stack && stack.querySelector('[data-sa-compare-atc]');
          if (!table || !atc) return;
          if (this._onCompareTableScroll) {
            table.removeEventListener('scroll', this._onCompareTableScroll);
            atc.removeEventListener('scroll', this._onCompareAtcScroll);
          }
          let lock = false;
          const sync = (from, to) => {
            if (lock) return;
            lock = true;
            to.scrollLeft = from.scrollLeft;
            requestAnimationFrame(() => {
              lock = false;
            });
          };
          this._onCompareTableScroll = () => sync(table, atc);
          this._onCompareAtcScroll = () => sync(atc, table);
          table.addEventListener('scroll', this._onCompareTableScroll, { passive: true });
          atc.addEventListener('scroll', this._onCompareAtcScroll, { passive: true });
        }

        compareCatalogKey() {
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          url.searchParams.delete('view');
          url.searchParams.delete('section_id');
          return `${url.pathname}?${url.searchParams.toString()}`;
        }

        escapeCompareText(value) {
          const node = document.createElement('div');
          node.textContent = value == null ? '' : String(value);
          return node.innerHTML;
        }

        addCompareCatalogItem(catalog, seen, item) {
          const id = String(item?.id || '');
          if (!id || seen.has(id)) return;
          seen.add(id);
          catalog.push({
            id,
            title: item.title || '',
            image: item.image || '',
          });
        }

        readCompareCatalogFromJson() {
          const catalog = [];
          const seen = new Set();
          try {
            const jsonEl = this.querySelector('[data-sa-compare-catalog]');
            const parsed = jsonEl?.textContent ? JSON.parse(jsonEl.textContent) : [];
            parsed.forEach((item) => this.addCompareCatalogItem(catalog, seen, item));
          } catch (error) {}
          return { catalog, seen };
        }

        readCompareOptionsFromDoc(doc, catalog, seen) {
          const select = doc.querySelector('[data-sa-compare-options]');
          if (!select) return 1;
          select.querySelectorAll('option').forEach((option) => {
            this.addCompareCatalogItem(catalog, seen, {
              id: option.value,
              title: (option.textContent || '').trim(),
              image: option.dataset.image || '',
            });
          });
          return Number(select.dataset.pages) || 1;
        }

        async loadCompareCatalog() {
          const key = this.compareCatalogKey();
          if (this._compareCatalog && this._compareCatalogKey === key) {
            return this._compareCatalog;
          }

          const { catalog, seen } = this.readCompareCatalogFromJson();

          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('page');
            url.searchParams.set('view', 'compare-options');
            const response = await fetch(`${url.pathname}?${url.searchParams.toString()}`);
            if (response.ok) {
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              if (doc.querySelector('[data-sa-compare-options]')) {
                catalog.length = 0;
                seen.clear();
                const pages = this.readCompareOptionsFromDoc(doc, catalog, seen);
                for (let page = 2; page <= pages && page <= 10; page += 1) {
                  url.searchParams.set('page', String(page));
                  const nextResponse = await fetch(`${url.pathname}?${url.searchParams.toString()}`);
                  if (!nextResponse.ok) break;
                  const nextDoc = new DOMParser().parseFromString(await nextResponse.text(), 'text/html');
                  this.readCompareOptionsFromDoc(nextDoc, catalog, seen);
                }
              }
            }
          } catch (error) {
            if (error.name !== 'AbortError') console.error(error);
          }

          this.compareItems.forEach((item) => this.addCompareCatalogItem(catalog, seen, item));
          this._compareCatalog = catalog;
          this._compareCatalogKey = key;
          return catalog;
        }

        fillCompareSelects() {
          const modal = this.compareModal;
          const catalog = this._compareCatalog || [];
          if (!modal || !catalog.length) return;

          modal.querySelectorAll('[data-sa-compare-swap]').forEach((select) => {
            const selectedId = String(this.compareItems[Number(select.dataset.index)]?.id || select.value);
            select.innerHTML = catalog
              .map((item) => {
                const selected = String(item.id) === selectedId ? ' selected' : '';
                return `<option value="${item.id}" data-image="${this.escapeCompareText(item.image)}"${selected}>${this.escapeCompareText(item.title)}</option>`;
              })
              .join('');
            select.value = selectedId;
          });
        }

        swapCompareColumn(index, id) {
          const targetId = String(id);
          const current = this.compareItems[index];
          if (!current || String(current.id) === targetId) return;

          const from = this.compareItems.findIndex((item) => String(item.id) === targetId);
          const next = this.compareItems.slice();
          if (from >= 0) {
            next[index] = this.compareItems[from];
            next[from] = current;
          } else {
            const catalogItem = (this._compareCatalog || []).find((item) => String(item.id) === targetId);
            if (!catalogItem) return;
            next[index] = {
              id: catalogItem.id,
              title: catalogItem.title,
              image: catalogItem.image || '',
            };
          }
          this.compareItems = next;
          this.syncCompareUI();
        }

        onChange(event) {
          const swap = event.target.closest('[data-sa-compare-swap]');
          if (swap) {
            this.swapCompareColumn(Number(swap.dataset.index), swap.value);
            return;
          }
          if (!event.target.closest('[data-sa-filters-form]')) return;
          if (event.target.closest('[data-sa-price]') && event.target.matches('input[type="range"]')) {
            this.syncPrice(event.target.closest('[data-sa-price]'), event.target);
            this.queueSubmit();
            return;
          }
          if (event.target.matches('[data-sa-price-min], [data-sa-price-max]')) {
            this.syncPriceFromFields(event.target.closest('[data-sa-price]'));
          }
          this.queueSubmit();
        }

        onInput(event) {
          if (event.target.closest('[data-sa-price]') && event.target.matches('input[type="range"]')) {
            this.syncPrice(event.target.closest('[data-sa-price]'), event.target);
          }
        }

        onPop() {
          this.render(window.location.href, false);
        }

        queueSubmit() {
          clearTimeout(this._timer);
          this._timer = setTimeout(() => this.submitForm(), 350);
        }

        submitForm() {
          const form = this.querySelector('[data-sa-filters-form]');
          if (!form) return;
          const params = new URLSearchParams();
          const price = form.querySelector('[data-sa-price]');
          const minDefault = price ? Number(price.dataset.min) : 0;
          const maxDefault = price ? Number(price.dataset.max) : 0;

          Array.from(new FormData(form).entries()).forEach(([key, value]) => {
            if (value === '' || value == null) return;
            if (price && key === price.querySelector('[data-sa-price-min]')?.name) {
              if (Number(value) <= minDefault) return;
            }
            if (price && key === price.querySelector('[data-sa-price-max]')?.name) {
              if (Number(value) >= maxDefault) return;
            }
            params.append(key, value);
          });

          const url = `${window.location.pathname}?${params.toString()}`;
          this.render(url, true);
        }

        render(url, push) {
          const sectionId = this.dataset.sectionId;
          if (!sectionId || !url) return;
          const next = new URL(url, window.location.origin);
          next.searchParams.set('section_id', sectionId);
          this.classList.add('is-loading');
          if (this._abort) this._abort.abort();
          this._abort = new AbortController();

          fetch(`${next.pathname}?${next.searchParams.toString()}`, { signal: this._abort.signal })
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const nextRoot = doc.querySelector('sa-collection');
              const nextMain = nextRoot && nextRoot.querySelector('[data-sa-collection-main]');
              const main = this.querySelector('[data-sa-collection-main]');
              if (!nextMain || !main) return;
              const open = this.classList.contains('is-filters-open');
              main.innerHTML = nextMain.innerHTML;
              this._compareCatalog = null;
              this._compareCatalogKey = null;
              this.setOpen(open, false);
              this.initPrice();
              this.syncCompareUI();
              if (this.classList.contains('is-compare')) this.loadCompareCatalog();
              if (push) {
                next.searchParams.delete('section_id');
                const query = next.searchParams.toString();
                window.history.pushState({}, '', query ? `${next.pathname}?${query}` : next.pathname);
              }
              document.dispatchEvent(new CustomEvent('page:reloaded'));
            })
            .catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            })
            .finally(() => {
              this.classList.remove('is-loading');
            });
        }

        initPrice() {
          this.querySelectorAll('[data-sa-price]').forEach((root) => this.syncPrice(root));
        }

        syncPriceFromFields(root) {
          if (!root) return;
          const low = root.querySelector('[data-sa-price-low]');
          const high = root.querySelector('[data-sa-price-high]');
          const minInput = root.querySelector('[data-sa-price-min]');
          const maxInput = root.querySelector('[data-sa-price-max]');
          if (!low || !high || !minInput || !maxInput) return;
          low.value = minInput.value;
          high.value = maxInput.value;
          this.syncPrice(root);
        }

        syncPrice(root, source) {
          if (!root) return;
          const min = Number(root.dataset.min) || 0;
          const max = Number(root.dataset.max) || 0;
          const low = root.querySelector('[data-sa-price-low]');
          const high = root.querySelector('[data-sa-price-high]');
          const minInput = root.querySelector('[data-sa-price-min]');
          const maxInput = root.querySelector('[data-sa-price-max]');
          const fill = root.querySelector('[data-sa-price-fill]');
          if (!low || !high) return;

          let a = Number(low.value);
          let b = Number(high.value);
          if (source === low && a > b) a = b;
          if (source === high && b < a) b = a;
          a = Math.min(Math.max(a, min), max);
          b = Math.min(Math.max(b, min), max);
          low.value = a;
          high.value = b;
          if (minInput) minInput.value = a;
          if (maxInput) maxInput.value = b;
          if (fill && max > min) {
            const start = ((a - min) / (max - min)) * 100;
            const end = ((b - min) / (max - min)) * 100;
            fill.style.left = `${start}%`;
            fill.style.width = `${Math.max(end - start, 0)}%`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function saFaqWraps(root) {
      const groups = root.querySelector('[data-faq-groups]');
      return groups ? Array.from(groups.children) : [];
    }

    function setSaFaqTab(root, index, scrollTab) {
      const wraps = saFaqWraps(root);
      const tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
      wraps.forEach(function (wrap, i) {
        wrap.classList.toggle('is-active', i === index);
      });
      tabs.forEach(function (tab, i) {
        const on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
        if (on && scrollTab) {
          tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
      });
    }

    function initSaFaq(root) {
      if (!root || root.dataset.saFaqReady === 'true') return;
      const tabBar = root.querySelector('[data-faq-tabs]');
      const template = root.querySelector('[data-faq-tab-template]');
      const wraps = saFaqWraps(root);
      if (!tabBar || !template || wraps.length === 0) return;

      root.dataset.saFaqReady = 'true';
      const btnTemplate = template.content.querySelector('button');
      if (!btnTemplate) return;

      tabBar.replaceChildren();
      wraps.forEach(function (wrap, i) {
        const panel = wrap.matches('[data-faq-panel]') ? wrap : wrap.querySelector('[data-faq-panel]');
        const btn = btnTemplate.cloneNode(true);
        const label = panel && panel.getAttribute('data-faq-label') ? panel.getAttribute('data-faq-label') : '';
        btn.textContent = label;
        btn.dataset.faqTab = String(i);
        btn.id = 'sa-faq-tab-' + root.id + '-' + i;
        if (panel && panel.id) btn.setAttribute('aria-controls', panel.id);
        if (i === 0) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          btn.setAttribute('tabindex', '0');
        } else {
          btn.setAttribute('aria-selected', 'false');
          btn.setAttribute('tabindex', '-1');
        }
        btn.addEventListener('click', function () {
          setSaFaqTab(root, i, true);
        });
        tabBar.appendChild(btn);
      });

      const ctaSource = root.querySelector('[data-faq-groups] [data-faq-cta]');
      const ctaMount = root.querySelector('[data-faq-mobile-cta]');
      if (ctaSource && ctaMount) {
        ctaMount.replaceChildren(ctaSource.cloneNode(true));
      }

      setSaFaqTab(root, 0, false);
    }

    function startSaFaq(container) {
      const scope = container || document;
      const roots =
        scope.classList && scope.classList.contains('sa-faq')
          ? [scope]
          : Array.from(scope.querySelectorAll('.sa-faq'));
      roots.forEach(initSaFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        startSaFaq(document);
      });
    } else {
      startSaFaq(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      startSaFaq(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      const root = event.target.closest('.sa-faq');
      if (!root) return;
      const wraps = saFaqWraps(root);
      const wrap = event.target.closest('[data-faq-groups] > *');
      const index = wraps.indexOf(wrap);
      if (index >= 0) setSaFaqTab(root, index, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-header"] && !Shopify.designMode) return;
  try {
    
  class SaHeader extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.overlay = this.dataset.overlay === 'true';
      this.megaRoot = this.querySelector('[data-sa-mega-root]');
      this.megaDim = this.querySelector('[data-sa-mega-dim]');
      this.drawer = this.querySelector('[data-sa-drawer]');
      this.drawerOverlay = this.querySelector('[data-sa-drawer-overlay]');
      this.drawerRoot = this.querySelector('[data-sa-drawer-root]');
      this.drawerChrome = this.querySelector('[data-sa-drawer-chrome]');
      this.navItems = this.querySelectorAll('[data-sa-nav-item]');
      this._megaClosing = false;
      this._onMegaHeightEnd = this._onMegaHeightEnd.bind(this);

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onSearchOpen = this._onSearchOpen.bind(this);
      this._onSearchClose = this._onSearchClose.bind(this);
      this._onDocClick = this._onDocClick.bind(this);

      this._measure();
      this._onScroll();

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      document.addEventListener('keyup', this._onKey);
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('searchmodal:open', this._onSearchOpen);
      document.addEventListener('searchmodal:close', this._onSearchClose);
      if (document.body.classList.contains('search-modal--open')) this._onSearchOpen();

      this._resizeObserver = new ResizeObserver(() => this._measure());
      this._resizeObserver.observe(this);

      this.navItems.forEach((item) => {
        const megaTrigger = item.querySelector('[data-sa-mega-trigger]');
        const dropTrigger = item.querySelector('[data-sa-dropdown-trigger]');
        if (megaTrigger) {
          megaTrigger.addEventListener('click', (event) => {
            if (this._isModifiedClick(event)) return;
            event.preventDefault();
            if (megaTrigger.getAttribute('aria-expanded') === 'true') this.closeMega();
            else this.openMega(item.dataset.mega);
          });
        } else if (dropTrigger) {
          dropTrigger.addEventListener('click', (event) => {
            if (this._isModifiedClick(event)) return;
            event.preventDefault();
            if (dropTrigger.getAttribute('aria-expanded') === 'true') this.closeDropdown();
            else this.openDropdown(item.dataset.dropdown);
          });
        }
      });

      if (this.megaDim) {
        this.megaDim.addEventListener('click', () => {
          this.closeMega();
          this.closeDropdown();
        });
      }

      this.querySelectorAll('[data-sa-drawer-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.openDrawer());
      });
      this.querySelectorAll('[data-sa-drawer-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.closeDrawer());
      });
      this.querySelectorAll('[data-sa-drawer-back]').forEach((btn) => {
        btn.addEventListener('click', () => this.drawerBack(btn));
      });
      this.querySelectorAll('[data-sa-drawer-panel-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.openDrawerPanel(btn.getAttribute('data-sa-drawer-panel-open')));
      });
      this.querySelectorAll('[data-sa-mega-toggle]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleMegaGroup(btn);
        });
      });
      if (this.drawerOverlay) {
        this.drawerOverlay.addEventListener('click', () => this.closeDrawer());
      }

      this.querySelectorAll('[data-sa-search-open]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const summary = this.querySelector('.sa-header__search summary');
          const link = this.querySelector('.sa-header__search .search-link');
          if (summary) summary.click();
          else if (link) link.click();
        });
      });

      this.querySelectorAll('[data-sa-mega-pane]').forEach((el) => {
        el.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 1000px)').matches) this.selectMegaPane(el);
        });
        el.addEventListener('focus', () => {
          if (!window.matchMedia('(min-width: 1000px)').matches) return;
          this.selectMegaPane(el);
        });
        el.addEventListener('click', (event) => {
          if (!window.matchMedia('(min-width: 1000px)').matches) return;
          event.preventDefault();
          this.selectMegaPane(el);
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('keyup', this._onKey);
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('searchmodal:open', this._onSearchOpen);
      document.removeEventListener('searchmodal:close', this._onSearchClose);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    _measure() {
      const rect = this.getBoundingClientRect();
      const headerHeight = Math.round(rect.height);
      const headerBottom = Math.max(0, Math.round(rect.bottom));
      const root = document.documentElement;
      root.style.setProperty('--sa-header-height', headerHeight + 'px');
      root.style.setProperty('--sa-header-bottom-offset', headerBottom + 'px');
      root.style.setProperty('--header-height', headerHeight + 'px');
      root.style.setProperty('--sticky-header-height', headerHeight + 'px');
    }

    _onResize() {
      this._measure();
      if (window.matchMedia('(min-width: 1000px)').matches) this.closeDrawer();
    }

    _onSearchOpen() {
      this.closeMega();
      this.closeDropdown();
      this.classList.add('is-search-open');
      this._onScroll();
    }

    _onSearchClose() {
      this.classList.remove('is-search-open');
      this._onScroll();
    }

    _onScroll() {
      const headerBottom = Math.max(0, Math.round(this.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--sa-header-bottom-offset', headerBottom + 'px');
      if (!this.overlay) return;
      this.classList.toggle('is-solid', window.scrollY > 8 || this.classList.contains('is-search-open'));
    }

    _onKey(event) {
      if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
      this.closeMega();
      this.closeDropdown();
      this.closeDrawer();
    }

    _isModifiedClick(event) {
      return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
    }

    _onDocClick(event) {
      if (!this.classList.contains('is-mega-open') && !this.classList.contains('is-dropdown-open')) return;
      const el = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!el) return;
      if (el.closest('[data-sa-mega-trigger], [data-sa-dropdown-trigger], [data-sa-mega-root], [data-sa-dropdown-panel], [data-sa-mega-dim]')) return;
      this.closeMega();
      this.closeDropdown();
    }

    _canAnimateMegaHeight() {
      return Boolean(
        this.megaRoot &&
          window.matchMedia('(min-width: 1000px)').matches &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    _megaMaxHeight() {
      const headerH = this.getBoundingClientRect().height || parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sa-header-height')) || 120;
      return Math.max(0, window.innerHeight - headerH);
    }

    _prepareMegaHeight(start) {
      if (!this.megaRoot || !window.matchMedia('(min-width: 1000px)').matches) return;
      const root = this.megaRoot;
      const from = start == null ? root.getBoundingClientRect().height : start;
      root.classList.remove('is-height-animating');
      root.style.height = from + 'px';
      void root.offsetHeight;
    }

    _readMegaNaturalHeight() {
      const root = this.megaRoot;
      if (!root) return 0;
      const height = root.style.height;
      root.classList.remove('is-height-animating');
      root.style.height = 'auto';
      const natural = root.scrollHeight;
      root.style.height = height;
      void root.offsetHeight;
      return Math.min(natural, this._megaMaxHeight());
    }

    _animateMegaHeight(end, onDone) {
      if (!this.megaRoot) {
        if (onDone) onDone();
        return;
      }
      const root = this.megaRoot;
      this._megaHeightToken = (this._megaHeightToken || 0) + 1;
      const token = this._megaHeightToken;
      this._megaHeightDone = onDone || null;
      root.removeEventListener('transitionend', this._onMegaHeightEnd);

      if (!this._canAnimateMegaHeight()) {
        root.style.height = end == null ? '' : end + 'px';
        root.classList.remove('is-height-animating');
        this._onMegaHeightEnd({ target: root, propertyName: 'height' });
        return;
      }

      const to = end == null ? this._readMegaNaturalHeight() : Math.min(end, this._megaMaxHeight());
      const from = root.getBoundingClientRect().height;
      if (Math.abs(to - from) < 1.5) {
        root.style.height = to + 'px';
        this._onMegaHeightEnd({ target: root, propertyName: 'height' });
        return;
      }

      root.classList.add('is-height-animating');
      root.style.height = to + 'px';
      this._megaHeightToken = token;
      root.addEventListener('transitionend', this._onMegaHeightEnd);
    }

    _onMegaHeightEnd(event) {
      if (!this.megaRoot || event.target !== this.megaRoot || event.propertyName !== 'height') return;
      this.megaRoot.removeEventListener('transitionend', this._onMegaHeightEnd);
      this.megaRoot.classList.remove('is-height-animating');
      const done = this._megaHeightDone;
      this._megaHeightDone = null;
      if (this._megaClosing) {
        if (done) done();
        return;
      }
      this.megaRoot.style.height = '';
      if (done) done();
    }

    _resetMegaHeight() {
      if (!this.megaRoot) return;
      this.megaRoot.removeEventListener('transitionend', this._onMegaHeightEnd);
      this.megaRoot.classList.remove('is-height-animating');
      this.megaRoot.style.height = '';
      this.megaRoot.style.transition = '';
      this._megaHeightDone = null;
    }

    selectMegaPane(trigger, options) {
      const id = trigger && trigger.getAttribute('data-sa-mega-pane');
      const tree = trigger && trigger.closest('[data-sa-mega-tree]');
      if (!id || !tree) return;

      const skipHeight = options && options.skipHeight;
      const current = tree.querySelector('[data-sa-mega-cards]:not([hidden])');
      const samePane = current && current.getAttribute('data-sa-mega-cards') === id;
      const desktop = window.matchMedia('(min-width: 1000px)').matches;
      if (!samePane && desktop && !skipHeight) this._prepareMegaHeight();

      tree.querySelectorAll('[data-sa-mega-cards]').forEach((el) => {
        el.hidden = el.getAttribute('data-sa-mega-cards') !== id;
      });
      tree.querySelectorAll('[data-sa-mega-pane]').forEach((el) => {
        const on = el.getAttribute('data-sa-mega-pane') === id;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
      tree.querySelectorAll('[data-sa-mega-group]').forEach((group) => {
        const childOn = Boolean(group.querySelector('[data-sa-mega-pane].is-active'));
        const l2 = group.querySelector('.sa-header__mega-l2');
        if (l2) l2.classList.toggle('is-active', childOn);
        if (desktop) {
          group.classList.add('is-open');
          return;
        }
        group.classList.toggle('is-open', childOn);
        const toggle = group.querySelector('[data-sa-mega-toggle], [data-sa-mega-l2]');
        if (toggle) toggle.setAttribute('aria-expanded', childOn ? 'true' : 'false');
      });
      const shop = tree.querySelector('[data-sa-mega-shop-all]');
      const shopUrl = trigger.getAttribute('data-sa-mega-shop-url');
      if (shop && shopUrl) shop.setAttribute('href', shopUrl);
      if (!samePane && desktop && !skipHeight) this._animateMegaHeight();
      requestAnimationFrame(() => {
        trigger.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    openMega(id) {
      if (!id || !this.megaRoot) return;
      this.closeDropdown();
      this._megaClosing = false;
      const alreadyOpen = this.classList.contains('is-mega-open');
      const desktop = window.matchMedia('(min-width: 1000px)').matches;
      if (desktop) this._prepareMegaHeight(alreadyOpen ? null : 0);
      this.querySelectorAll('[data-sa-mega-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-sa-mega-panel') !== id;
      });
      this.querySelectorAll('[data-sa-mega-trigger]').forEach((trigger) => {
        const item = trigger.closest('[data-sa-nav-item]');
        trigger.setAttribute('aria-expanded', item && item.dataset.mega === id ? 'true' : 'false');
      });
      this.classList.add('is-mega-open');
      document.body.classList.add('mega-menu-opened');
      if (this.megaDim) this.megaDim.hidden = false;

      const panel = this.querySelector('[data-sa-mega-panel="' + id + '"]');
      const def = panel && (panel.querySelector('[data-sa-mega-pane][data-sa-mega-default]') || panel.querySelector('[data-sa-mega-pane]'));
      if (def) this.selectMegaPane(def, { skipHeight: true });
      if (desktop) this._animateMegaHeight();
    }

    openDropdown(id) {
      if (!id) return;
      this.closeMega();
      this.querySelectorAll('[data-sa-dropdown-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-sa-dropdown-panel') !== id;
      });
      this.querySelectorAll('[data-sa-dropdown-trigger]').forEach((trigger) => {
        const item = trigger.closest('[data-sa-nav-item]');
        trigger.setAttribute('aria-expanded', item && item.dataset.dropdown === id ? 'true' : 'false');
      });
      this.classList.add('is-dropdown-open');
    }

    closeDropdown() {
      this.querySelectorAll('[data-sa-dropdown-panel]').forEach((panel) => {
        panel.hidden = true;
      });
      this.querySelectorAll('[data-sa-dropdown-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      this.classList.remove('is-dropdown-open');
    }

    closeMega() {
      this.querySelectorAll('[data-sa-mega-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (this.megaDim) this.megaDim.hidden = true;

      const finish = () => {
        this.querySelectorAll('[data-sa-mega-panel]').forEach((panel) => {
          panel.hidden = true;
        });
        this.classList.remove('is-mega-open');
        document.body.classList.remove('mega-menu-opened');
        this._resetMegaHeight();
        this._megaClosing = false;
      };

      if (!this.classList.contains('is-mega-open')) {
        finish();
        return;
      }

      this._megaClosing = true;
      if (window.matchMedia('(min-width: 1000px)').matches) {
        this._prepareMegaHeight();
        this._animateMegaHeight(0, finish);
        return;
      }
      finish();
    }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      if (this.drawerOverlay) this.drawerOverlay.hidden = false;
      this.querySelector('[data-sa-drawer-open]')?.setAttribute('aria-expanded', 'true');
      this.showDrawerRoot();
      requestAnimationFrame(() => {
        this.classList.add('is-drawer-open');
        document.body.classList.add('sa-drawer-open');
      });
    }

    closeDrawer() {
      this.classList.remove('is-drawer-open');
      document.body.classList.remove('sa-drawer-open');
      this.querySelector('[data-sa-drawer-open]')?.setAttribute('aria-expanded', 'false');
      this.showDrawerRoot();
      setTimeout(() => {
        if (this.classList.contains('is-drawer-open')) return;
        if (this.drawer) this.drawer.hidden = true;
        if (this.drawerOverlay) this.drawerOverlay.hidden = true;
      }, 350);
    }

    setDrawerChrome(visible) {
      if (this.drawerChrome) this.drawerChrome.hidden = !visible;
    }

    drawerBack(btn) {
      const panel = btn && btn.closest('[data-sa-drawer-panel]');
      const parent = panel && panel.getAttribute('data-sa-drawer-parent');
      if (parent) this.openDrawerPanel(parent);
      else this.showDrawerRoot();
    }

    toggleMegaGroup(button) {
      const group = button && button.closest('[data-sa-mega-group]');
      const tree = button && button.closest('[data-sa-mega-tree]');
      if (!group || !tree) return;
      const willOpen = !group.classList.contains('is-open');
      tree.querySelectorAll('[data-sa-mega-group]').forEach((item) => {
        const open = willOpen && item === group;
        item.classList.toggle('is-open', open);
        const l2 = item.querySelector('[data-sa-mega-toggle], [data-sa-mega-l2]');
        if (l2) l2.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    showDrawerRoot() {
      if (this.drawerRoot) this.drawerRoot.hidden = false;
      this.querySelectorAll('[data-sa-drawer-panel]').forEach((panel) => {
        panel.hidden = true;
      });
      this.setDrawerChrome(true);
    }

    openDrawerPanel(id) {
      if (!id) return;
      if (this.drawerRoot) this.drawerRoot.hidden = true;
      const panel = this.querySelector('[data-sa-drawer-panel="' + id + '"]');
      this.querySelectorAll('[data-sa-drawer-panel]').forEach((el) => {
        el.hidden = el !== panel;
      });
      this.setDrawerChrome(!(panel && panel.hasAttribute('data-sa-drawer-parent')));
    }
  }

  if (!customElements.get('sa-header')) {
    customElements.define('sa-header', SaHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-heritage-moment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function arm(root) {
      if (!root || root.dataset.hmBound === 'true') return;
      root.dataset.hmBound = 'true';
      if (root.dataset.motion === 'off' || reduceMotion) return;
      if (window.Shopify && window.Shopify.designMode) return;

      root.classList.add('is-armed');

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-in');
            observer.disconnect();
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
      );

      observer.observe(root);
    }

    function boot(scope) {
      var context = scope || document;
      context.querySelectorAll('[data-heritage-moment]').forEach(arm);
    }

    boot();

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-heritage-moment]');
      if (!root) return;
      delete root.dataset.hmBound;
      root.classList.remove('is-armed', 'is-in');
      arm(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-heritage-spacewalk"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function arm(root) {
      if (!root || root.dataset.swBound === 'true') return;
      root.dataset.swBound = 'true';
      if (root.dataset.motion === 'off' || reduceMotion) return;
      if (window.Shopify && window.Shopify.designMode) return;

      root.classList.add('is-armed');

      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.classList.add('is-in');
            observer.disconnect();
          });
        },
        { threshold: 0.45, rootMargin: '0px 0px -10% 0px' }
      );

      observer.observe(root.querySelector('.sa-sw__stage') || root);
    }

    function boot(scope) {
      var context = scope || document;
      context.querySelectorAll('[data-heritage-spacewalk]').forEach(arm);
    }

    boot();

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-heritage-spacewalk]');
      if (!root) return;
      delete root.dataset.swBound;
      root.classList.remove('is-armed', 'is-in');
      arm(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-heritage"] && !Shopify.designMode) return;
  try {
    
  function isSaHeritagePaintNone(value) {
    if (!value) return false;
    var v = String(value).trim().toLowerCase();
    return v === 'none' || v === 'transparent';
  }

  function paintSaHeritageTabSvg(svg) {
    if (!svg || svg.dataset.heritagePainted === 'true') return;
    svg.dataset.heritagePainted = 'true';
    svg.setAttribute('fill', 'currentColor');

    Array.from(svg.querySelectorAll('*')).forEach(function (el) {
      var fill = el.getAttribute('fill');
      if (fill) {
        if (!isSaHeritagePaintNone(fill)) el.setAttribute('fill', 'currentColor');
      } else if (/^(path|polygon|circle|ellipse|rect|text|tspan)$/i.test(el.tagName)) {
        el.setAttribute('fill', 'currentColor');
      }

      var stroke = el.getAttribute('stroke');
      if (stroke && !isSaHeritagePaintNone(stroke)) {
        el.setAttribute('stroke', 'currentColor');
      }

      if (el.style) {
        if (el.style.fill && !isSaHeritagePaintNone(el.style.fill)) el.style.fill = 'currentColor';
        if (el.style.stroke && !isSaHeritagePaintNone(el.style.stroke)) el.style.stroke = 'currentColor';
      }
    });
  }

  function paintSaHeritageTabSvgs(root) {
    if (!root) return;
    Array.from(root.querySelectorAll('.sa-heritage__tab-svg svg')).forEach(paintSaHeritageTabSvg);
  }

  function scrollSaHeritageTab(tabsEl, tab) {
    if (!tabsEl || !tab) return;
    var maxScroll = tabsEl.scrollWidth - tabsEl.clientWidth;
    if (maxScroll <= 1) return;

    var wrapRect = tabsEl.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var gutter = window.matchMedia('(min-width: 1000px)').matches
      ? (wrapRect.width - tabRect.width) / 2
      : 48;
    var next = tabsEl.scrollLeft + (tabRect.left - wrapRect.left - gutter);
    if (next < 0) next = 0;
    if (next > maxScroll) next = maxScroll;
    if (Math.abs(next - tabsEl.scrollLeft) < 1) return;
    tabsEl.scrollTo({ left: next, behavior: 'smooth' });
  }

  function syncSaHeritage(root, index, scrollTab) {
    if (!root) return;
    const tabs = Array.from(root.querySelectorAll('[data-heritage-tab]'));
    const tabsEl = root.querySelector('[data-heritage-tabs]');
    const medias = Array.from(root.querySelectorAll('[data-heritage-media]'));

    tabs.forEach(function (tab, i) {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scrollTab) scrollSaHeritageTab(tabsEl, tab);
    });

    if (medias.length > 1) {
      medias.forEach(function (media, i) {
        media.classList.toggle('is-active', i === index);
      });
    }
  }

  function initSaHeritageAwardsScroll(root) {
    if (!root) return;
    var wrap = root.querySelector('.sa-heritage__awards-wrap');
    var scroller = root.querySelector('.sa-heritage__awards--scroll');
    if (!wrap || !scroller) return;

    var desktopMq = window.matchMedia('(min-width: 1000px)');

    function originals() {
      return Array.from(
        scroller.querySelectorAll('.sa-heritage__award:not(.sa-heritage__award-clone)')
      );
    }

    function removeClones() {
      Array.from(scroller.querySelectorAll('.sa-heritage__award-clone')).forEach(function (el) {
        el.remove();
      });
      scroller.dataset.heritageAwardsMarquee = '';
      scroller.classList.remove('is-marquee');
      wrap.style.removeProperty('--heritage-award-w');
      scroller.style.removeProperty('--heritage-awards-duration');
    }

    function ensureClones() {
      var items = originals();
      if (items.length < 4) return false;
      if (scroller.dataset.heritageAwardsMarquee === 'true') return true;
      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.classList.add('sa-heritage__award-clone');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        scroller.appendChild(clone);
      });
      scroller.dataset.heritageAwardsMarquee = 'true';
      return true;
    }

    function sizeAwards() {
      var items = originals();
      if (!desktopMq.matches || items.length < 4) {
        removeClones();
        return;
      }
      if (!ensureClones()) return;
      scroller.classList.add('is-marquee');
      var styles = window.getComputedStyle(wrap);
      var inner =
        wrap.clientWidth - (parseFloat(styles.paddingLeft) || 0) - (parseFloat(styles.paddingRight) || 0);
      if (inner <= 0) return;
      wrap.style.setProperty('--heritage-award-w', inner / 3 + 'px');
      scroller.style.setProperty('--heritage-awards-duration', items.length * 4 + 's');
    }

    sizeAwards();
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', sizeAwards);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(sizeAwards);
    }
    if (typeof ResizeObserver === 'function' && !wrap._saHeritageAwardsRo) {
      var ro = new ResizeObserver(sizeAwards);
      ro.observe(wrap);
      wrap._saHeritageAwardsRo = ro;
    }
  }

  function initSaHeritage(root) {
    if (!root) return;
    paintSaHeritageTabSvgs(root);
    initSaHeritageAwardsScroll(root);
    if (root.dataset.heritageReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = root.querySelector('[data-heritage-swiper]');
    if (!swiperEl || swiperEl.swiper) {
      if (swiperEl && swiperEl.swiper) root.dataset.heritageReady = 'true';
      return;
    }

    root.dataset.heritageReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-heritage-tab]'));
    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    const swiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      roundLengths: true,
      watchOverflow: true,
      allowTouchMove: slideCount > 1,
      breakpoints: {
        1000: {
          autoHeight: false,
        },
      },
      on: {
        init: function (swiperInstance) {
          syncSaHeritage(root, swiperInstance.realIndex, false);
        },
        slideChange: function (swiperInstance) {
          syncSaHeritage(root, swiperInstance.realIndex, true);
        },
      },
    });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        scrollSaHeritageTab(root.querySelector('[data-heritage-tabs]'), tab);
        swiper.slideTo(i);
      });
    });

    root._saHeritageSwiper = swiper;
  }

  function initSaHeritages(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-heritage')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-heritage'));
    sections.forEach(initSaHeritage);
  }

  function whenSaHeritageSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaHeritage() {
    Array.from(document.querySelectorAll('.sa-heritage')).forEach(function (section) {
      paintSaHeritageTabSvgs(section);
      initSaHeritageAwardsScroll(section);
    });
    whenSaHeritageSwiperReady(function () {
      initSaHeritages();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaHeritage);
  } else {
    bootSaHeritage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    paintSaHeritageTabSvgs(event.target);
    initSaHeritageAwardsScroll(event.target);
    whenSaHeritageSwiperReady(function () {
      initSaHeritages(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-heritage');
    if (!root || !root._saHeritageSwiper) return;
    const slide = event.target.closest('.swiper-slide');
    const tab = event.target.closest('[data-heritage-tab]');
    let index = -1;
    if (slide) {
      const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      index = slides.indexOf(slide);
    } else if (tab) {
      const tabs = Array.from(root.querySelectorAll('[data-heritage-tab]'));
      index = tabs.indexOf(tab);
    }
    if (index >= 0) root._saHeritageSwiper.slideTo(index);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-hero"] && !Shopify.designMode) return;
  try {
    
  function syncSaHeroPaginationColor(root, swiperInstance) {
    const paginationEl = root.querySelector('.sa-hero-pagination');
    if (!paginationEl || !swiperInstance) return;
    const slide = swiperInstance.slides[swiperInstance.activeIndex];
    const color = slide?.getAttribute('data-pagination-color') || '#ffffff';
    const track = slide?.getAttribute('data-pagination-track') || 'rgba(255, 255, 255, 0.4)';
    paginationEl.style.setProperty('--hero-pagination-color', color);
    paginationEl.style.setProperty('--hero-pagination-track', track);
  }

  function initSaHeroSwiper(root) {
    if (typeof Swiper === 'undefined' || !root) return;
    const swiperEl = root.querySelector('.swiper');
    if (!swiperEl || swiperEl.swiper) return;

    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(Number(root.dataset.delay) || 5000, 1000);
    const paginationEl = root.querySelector('.sa-hero-pagination');
    const nextEl = root.querySelector('.swiper-button-next');
    const prevEl = root.querySelector('.swiper-button-prev');
    const options = {
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      speed: 600,
      loop: slideCount > 1,
      allowTouchMove: slideCount > 1,
      autoplay:
        autoplay && slideCount > 1
          ? { delay: delay, disableOnInteraction: false }
          : false,
      on: {
        afterInit: function (swiperInstance) {
          syncSaHeroPaginationColor(root, swiperInstance);
        },
        slideChange: function (swiperInstance) {
          syncSaHeroPaginationColor(root, swiperInstance);
        },
      },
    };

    if (paginationEl) {
      options.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    if (nextEl && prevEl) {
      options.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    new Swiper(swiperEl, options);
  }

  function initSaHeroSwipers(scope) {
    const root = scope || document;
    const heroes = root.classList && root.classList.contains('sa-hero')
      ? [root]
      : Array.from(root.querySelectorAll('.sa-hero'));
    heroes.forEach(initSaHeroSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaHeroSwipers();
    });
  } else {
    initSaHeroSwipers();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaHeroSwipers(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-main-article"] && !Shopify.designMode) return;
  try {
    
  function whenSaMainArticleSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof Swiper !== 'undefined' || tries > 40) {
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') callback();
      }
    }, 50);
  }

  function initSaMainArticleMentioned(root) {
    if (!root || typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-mentioned-swiper]').forEach(function (swiperEl) {
      if (swiperEl.swiper) return;

      var slideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
      if (slideCount === 0) return;

      var stageEl = swiperEl.closest('.sa-article-mentioned__stage') || swiperEl.parentElement;
      var paginationEl = stageEl ? stageEl.querySelector('[data-mentioned-pagination]') : null;
      var prevEl = stageEl ? stageEl.querySelector('[data-mentioned-prev]') : null;
      var nextEl = stageEl ? stageEl.querySelector('[data-mentioned-next]') : null;

      new Swiper(swiperEl, {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        grabCursor: slideCount > 1,
        allowTouchMove: slideCount > 1,
        speed: 400,
        pagination:
          slideCount > 1 && paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : undefined,
        navigation:
          slideCount > 1 && prevEl && nextEl
            ? {
                prevEl: prevEl,
                nextEl: nextEl,
                disabledClass: 'is-disabled',
              }
            : undefined,
      });
    });
  }

  function initSaMainArticle(root) {
    if (!root || root.dataset.articleReady === 'true') return;
    root.dataset.articleReady = 'true';

    const shareButtons = root.querySelectorAll('[data-sa-share]');
    shareButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const url = button.getAttribute('data-share-url') || window.location.href;
        const title = button.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    });

    const topButton = root.querySelector('[data-sa-back-to-top]');
    if (topButton) {
      topButton.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    whenSaMainArticleSwiperReady(function () {
      initSaMainArticleMentioned(root);
    });
  }

  function initSaMainArticleSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-main-article')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-main-article'));
    sections.forEach(initSaMainArticle);
  }

  initSaMainArticleSections();
  document.addEventListener('shopify:section:load', function (event) {
    initSaMainArticleSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-main-blog"] && !Shopify.designMode) return;
  try {
    
  function initSaMainBlog(root) {
    if (!root || root.dataset.blogReady === 'true') return;
    const tabs = Array.from(root.querySelectorAll('[data-blog-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-blog-panel]'));
    if (tabs.length === 0 || panels.length === 0) return;

    root.dataset.blogReady = 'true';

    function setTab(key) {
      tabs.forEach(function (tab) {
        const on = tab.getAttribute('data-blog-tab') === key;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        const on = panel.getAttribute('data-blog-panel') === key;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setTab(tab.getAttribute('data-blog-tab'));
      });
    });
  }

  function initSaMainBlogSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-main-blog')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-main-blog'));
    sections.forEach(initSaMainBlog);
  }

  initSaMainBlogSections();
  document.addEventListener('shopify:section:load', function (event) {
    initSaMainBlogSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-cards"] && !Shopify.designMode) return;
  try {
    
  function saProductCardsActivePanel(root) {
    return root.querySelector('[data-cards-panel].is-active') || root.querySelector('[data-cards-panel]');
  }

  function saProductCardsActiveSwiper(root) {
    const panel = saProductCardsActivePanel(root);
    const el = panel && panel.querySelector('[data-cards-swiper]');
    return el && el.swiper ? el.swiper : null;
  }

  function saProductCardsIsActiveSwiper(root, swiper) {
    const active = saProductCardsActiveSwiper(root);
    return Boolean(root && swiper && active && active === swiper);
  }

  function syncSaProductCardsProgress(root, swiper) {
    if (!root) return;
    const instance = swiper || saProductCardsActiveSwiper(root);
    if (!instance) return;
    if (!saProductCardsIsActiveSwiper(root, instance)) return;

    const thumb = root.querySelector('[data-cards-progress-thumb]');
    const prevBtn = root.querySelector('[data-cards-prev]');
    const nextBtn = root.querySelector('[data-cards-next]');
    if (!thumb) return;

    const view = instance.size || 1;
    const total = instance.virtualSize || view;
    const ratio = Math.min(1, view / total);
    const progress = typeof instance.progress === 'number' ? Math.min(1, Math.max(0, instance.progress)) : 0;
    const travel = Math.max(0, 1 - ratio);
    const locked = instance.isLocked || (typeof instance.params.slidesPerView === 'number' && instance.slides.length <= instance.params.slidesPerView);
    thumb.style.width = (locked ? 1 : ratio) * 100 + '%';
    thumb.style.transform = locked || travel === 0 || ratio === 0
      ? 'translateX(0)'
      : 'translateX(' + ((progress * travel) / ratio) * 100 + '%)';

    if (prevBtn) {
      const disabled = locked || instance.isBeginning;
      prevBtn.classList.toggle('is-disabled', disabled);
      prevBtn.disabled = disabled;
      prevBtn.hidden = locked;
    }
    if (nextBtn) {
      const disabled = locked || instance.isEnd;
      nextBtn.classList.toggle('is-disabled', disabled);
      nextBtn.disabled = disabled;
      nextBtn.hidden = locked;
    }
  }

  function refreshSaProductCardsSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;
    if (!swiper.el || swiper.el.clientWidth === 0) return;
    if (typeof swiper.update === 'function') {
      swiper.update();
      return;
    }
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
  }

  function refreshAllSaProductCardsSwipers(root) {
    if (!root) return;
    root.querySelectorAll('[data-cards-swiper]').forEach(function (el) {
      if (el.swiper) refreshSaProductCardsSwiper(el.swiper);
    });
    syncSaProductCardsProgress(root, saProductCardsActiveSwiper(root));
  }

  function saProductCardsSwiperOptions(root) {
    return {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      grabCursor: true,
      allowTouchMove: true,
      speed: 500,
      spaceBetween: 0,
      breakpoints: {
        375: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
        1000: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
        1300: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        },
      },
      on: {
        init: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        progress: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        slideChange: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        fromEdge: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        reachBeginning: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        reachEnd: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
        breakpoint: function (swiperInstance) {
          refreshSaProductCardsSwiper(swiperInstance);
          syncSaProductCardsProgress(root, swiperInstance);
        },
        resize: function (swiperInstance) {
          syncSaProductCardsProgress(root, swiperInstance);
        },
      },
    };
  }

  function ensureSaProductCardsSwiper(root, panel) {
    if (!panel) return null;
    const swiperEl = panel.querySelector('[data-cards-swiper]');
    if (!swiperEl) return null;
    if (swiperEl.swiper) return swiperEl.swiper;
    if (swiperEl.clientWidth === 0) return null;
    return new Swiper(swiperEl, saProductCardsSwiperOptions(root));
  }

  function setSaProductCardsTab(root, index, scrollTab) {
    const tabs = Array.from(root.querySelectorAll('[data-cards-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cards-panel]'));
    const tabsEl = root.querySelector('[data-cards-tabs]');
    if (index < 0 || index >= panels.length) return;

    tabs.forEach(function (tab, i) {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scrollTab && tabsEl) {
        const target = tab.offsetLeft - (tabsEl.clientWidth - tab.offsetWidth) / 2;
        tabsEl.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    });

    panels.forEach(function (panel, i) {
      const on = i === index;
      panel.classList.toggle('is-active', on);
      if (on) panel.removeAttribute('aria-hidden');
      else panel.setAttribute('aria-hidden', 'true');
    });

    function apply() {
      const swiper = ensureSaProductCardsSwiper(root, panels[index]);
      if (!swiper) return;
      refreshSaProductCardsSwiper(swiper);
      syncSaProductCardsProgress(root, swiper);
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(apply);
    });
    root._saCardsIndex = index;
  }

  function bindSaProductCardsResize(root) {
    if (root._saCardsRo || typeof ResizeObserver === 'undefined') return;
    const stage = root.querySelector('.sa-product-cards__stage');
    if (!stage) return;

    var raf = 0;
    root._saCardsRo = new ResizeObserver(function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (root.dataset.cardsReady !== 'true' && typeof root._saCardsSetup === 'function') {
          root._saCardsSetup();
        }
        refreshAllSaProductCardsSwipers(root);
      });
    });
    root._saCardsRo.observe(stage);
  }

  function initSaProductCards(root) {
    if (!root || root.dataset.cardsReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const panels = Array.from(root.querySelectorAll('[data-cards-panel]'));
    if (panels.length === 0) return;

    if (root.dataset.cardsBound !== 'true') {
      root.dataset.cardsBound = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-cards-tab]'));
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          setSaProductCardsTab(root, i, true);
        });
      });

      const prevBtn = root.querySelector('[data-cards-prev]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          const panel = saProductCardsActivePanel(root);
          const swiper = panel && panel.querySelector('[data-cards-swiper]');
          if (swiper && swiper.swiper && !swiper.swiper.isBeginning) {
            swiper.swiper.slidePrev();
          }
        });
      }

      const nextBtn = root.querySelector('[data-cards-next]');
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          const panel = saProductCardsActivePanel(root);
          const swiper = panel && panel.querySelector('[data-cards-swiper]');
          if (swiper && swiper.swiper && !swiper.swiper.isEnd) {
            swiper.swiper.slideNext();
          }
        });
      }
    }

    function setup() {
      if (root.dataset.cardsReady === 'true') return true;
      const active = saProductCardsActivePanel(root) || panels[0];
      const swiperEl = active && active.querySelector('[data-cards-swiper]');
      if (!swiperEl || swiperEl.clientWidth === 0) return false;

      panels.forEach(function (panel) {
        ensureSaProductCardsSwiper(root, panel);
      });

      const activeIndex = Math.max(0, panels.indexOf(active));
      root.dataset.cardsReady = 'true';
      root._saCardsIndex = activeIndex;
      setSaProductCardsTab(root, activeIndex, false);
      bindSaProductCardsResize(root);
      refreshAllSaProductCardsSwipers(root);
      return true;
    }

    root._saCardsSetup = setup;

    if (!setup()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!setup()) bindSaProductCardsResize(root);
        });
      });
    }
  }

  function initSaProductCardsSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-product-cards')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-product-cards'));
    sections.forEach(initSaProductCards);
  }

  function whenSaProductCardsSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaProductCards() {
    whenSaProductCardsSwiperReady(function () {
      initSaProductCardsSections();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaProductCards);
  } else {
    bootSaProductCards();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.sa-product-cards').forEach(function (root) {
      if (root.dataset.cardsReady !== 'true') initSaProductCards(root);
      refreshAllSaProductCardsSwipers(root);
    });
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.sa-product-cards').forEach(function (root) {
      if (root.dataset.cardsReady !== 'true') initSaProductCards(root);
      refreshAllSaProductCardsSwipers(root);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    whenSaProductCardsSwiperReady(function () {
      initSaProductCardsSections(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-product-cards');
    if (!root) return;
    const tab = event.target.closest('[data-cards-tab]');
    const panel = event.target.closest('[data-cards-panel]');
    const tabs = Array.from(root.querySelectorAll('[data-cards-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cards-panel]'));
    let index = -1;
    if (tab) index = tabs.indexOf(tab);
    else if (panel) index = panels.indexOf(panel);
    if (index >= 0) setSaProductCardsTab(root, index, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-compare"] && !Shopify.designMode) return;
  try {
    
  function saProductCompareSync(root) {
    if (!root) return;
    const scroller = root.querySelector('[data-compare-scroll]');
    const thumb = root.querySelector('[data-compare-progress-thumb]');
    const bar = root.querySelector('[data-compare-progress]');
    if (!scroller || !thumb || !bar) return;

    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const ratio = 0.4;
    const progress = max > 0 ? scroller.scrollLeft / max : 0;
    const locked = max <= 1;

    bar.hidden = locked;
    thumb.style.width = (locked ? 1 : ratio) * 100 + '%';
    thumb.style.transform = locked
      ? 'translateX(0)'
      : 'translateX(' + (progress * ((1 - ratio) / ratio) * 100) + '%)';
  }

  function saProductCompareInit(root) {
    if (!root || root.dataset.compareReady === 'true') return;
    const scroller = root.querySelector('[data-compare-scroll]');
    if (!scroller) return;

    root.dataset.compareReady = 'true';
    const onSync = function () {
      saProductCompareSync(root);
    };

    scroller.addEventListener('scroll', onSync, { passive: true });
    window.addEventListener('resize', onSync);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onSync).observe(scroller);
    }
    onSync();
  }

  document.querySelectorAll('.sa-product-compare').forEach(saProductCompareInit);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.sa-product-compare') || event.target.closest('.sa-product-compare');
    if (!root) return;
    delete root.dataset.compareReady;
    saProductCompareInit(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-expand-gallery"] && !Shopify.designMode) return;
  try {
    
  function syncSaExpandGallery(root, swiperInstance) {
    if (!root) return;
    const bullets = Array.from(root.querySelectorAll('[data-expand-gallery-bullet]'));
    if (!bullets.length) return;
    const index = swiperInstance && typeof swiperInstance.realIndex === 'number' ? swiperInstance.realIndex : 0;
    bullets.forEach(function (bullet, i) {
      const active = i === index;
      bullet.classList.toggle('is-active', active);
      bullet.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function saExpandGalleryDesktopMq() {
    return window.matchMedia('(min-width: 1000px)');
  }

  function openSaExpandGalleryItem(item) {
    if (!item || item.classList.contains('is-open')) return;
    const row = item.closest('.sa-product-expand-gallery__row');
    if (!row) return;
    row.querySelectorAll('.sa-product-expand-gallery__item.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    item.classList.add('is-open');
  }

  function bindSaExpandGalleryDesktop(root) {
    if (!root || root.dataset.expandGalleryDesktopBound === 'true') return;
    const row = root.querySelector('.sa-product-expand-gallery__row');
    if (!row) return;
    root.dataset.expandGalleryDesktopBound = 'true';

    row.querySelectorAll('.sa-product-expand-gallery__item').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        openSaExpandGalleryItem(item);
      });
      item.addEventListener('focusin', function () {
        openSaExpandGalleryItem(item);
      });
    });
  }

  function createSaExpandGallerySwiper(root, swiperEl) {
    if (typeof Swiper === 'undefined' || !swiperEl || swiperEl.swiper) return;

    const slideCount = swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount === 0) return;

    const swiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      initialSlide: 0,
      grabCursor: slideCount > 1,
      watchOverflow: true,
      allowTouchMove: slideCount > 1,
      speed: 500,
      spaceBetween: 16,
      on: {
        init: function (swiperInstance) {
          syncSaExpandGallery(root, swiperInstance);
        },
        slideChange: function (swiperInstance) {
          syncSaExpandGallery(root, swiperInstance);
        },
      },
    });

    if (root.dataset.expandGalleryBound !== 'true') {
      root.querySelectorAll('[data-expand-gallery-bullet]').forEach(function (bullet, index) {
        bullet.addEventListener('click', function () {
          if (root._saExpandGallerySwiper) root._saExpandGallerySwiper.slideTo(index);
        });
      });
      root.dataset.expandGalleryBound = 'true';
    }

    root._saExpandGallerySwiper = swiper;
  }

  function destroySaExpandGallerySwiper(root, swiperEl) {
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
    root._saExpandGallerySwiper = null;
  }

  function syncSaExpandGalleryMode(root) {
    const swiperEl = root.querySelector('[data-expand-gallery-swiper]');
    if (!swiperEl) return;
    if (saExpandGalleryDesktopMq().matches) {
      destroySaExpandGallerySwiper(root, swiperEl);
    } else {
      createSaExpandGallerySwiper(root, swiperEl);
    }
  }

  function initSaExpandGallery(root) {
    if (!root) return;
    bindSaExpandGalleryDesktop(root);

    const swiperEl = root.querySelector('[data-expand-gallery-swiper]');
    if (!swiperEl) return;

    if (root.dataset.expandGalleryReady !== 'true') {
      root.dataset.expandGalleryReady = 'true';
      saExpandGalleryDesktopMq().addEventListener('change', function () {
        syncSaExpandGalleryMode(root);
      });
    }

    whenSaExpandGallerySwiperReady(function () {
      syncSaExpandGalleryMode(root);
    });
  }

  function initSaExpandGalleries(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-product-expand-gallery')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-product-expand-gallery'));
    sections.forEach(initSaExpandGallery);
  }

  function whenSaExpandGallerySwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaExpandGalleries();
    });
  } else {
    initSaExpandGalleries();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaExpandGalleries(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-product-expand-gallery');
    if (!root) return;
    const desktopItem = event.target.closest('.sa-product-expand-gallery__item');
    if (desktopItem) {
      openSaExpandGalleryItem(desktopItem);
      return;
    }
    const slide = event.target.closest('.swiper-slide');
    if (!slide || !root._saExpandGallerySwiper) return;
    const slides = Array.from(root.querySelectorAll('[data-expand-gallery-swiper] .swiper-wrapper > .swiper-slide'));
    const index = slides.indexOf(slide);
    if (index >= 0) root._saExpandGallerySwiper.slideTo(index);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-feature"] && !Shopify.designMode) return;
  try {
    
  const saProductFeatureState = {
    items: [],
    ticking: false,
    bound: false,
  };

  function saProductFeatureDesktop() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function saProductFeatureReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function saProductFeatureUpdate() {
    saProductFeatureState.ticking = false;
    const desktop = saProductFeatureDesktop();
    const reduced = saProductFeatureReduced();
    const vh = window.innerHeight || 1;

    saProductFeatureState.items = saProductFeatureState.items.filter(function (el) {
      return el.isConnected;
    });

    saProductFeatureState.items.forEach(function (feature) {
      if (feature.dataset.saFeatureExpand !== 'true' || !desktop) {
        feature.style.removeProperty('--feature-expand');
        return;
      }

      const rect = feature.getBoundingClientRect();
      const entered = (vh - rect.top) / vh;
      let progress = (entered - 0.2) / 0.6;
      if (progress < 0) progress = 0;
      else if (progress > 1) progress = 1;
      if (reduced) progress = entered >= 0.2 ? 1 : 0;
      feature.style.setProperty('--feature-expand', String(progress));
    });
  }

  function saProductFeatureOnScroll() {
    if (saProductFeatureState.ticking) return;
    saProductFeatureState.ticking = true;
    window.requestAnimationFrame(saProductFeatureUpdate);
  }

  function saProductFeatureBindScroll() {
    if (saProductFeatureState.bound) return;
    saProductFeatureState.bound = true;
    window.addEventListener('scroll', saProductFeatureOnScroll, { passive: true });
    window.addEventListener('resize', saProductFeatureOnScroll);
  }

  function initSaProductFeature(scope) {
    const root = scope || document;
    const features = Array.from(root.querySelectorAll('[data-sa-product-feature]'));
    if (root.matches && root.matches('[data-sa-product-feature]')) features.push(root);

    features.forEach(function (feature) {
      if (!feature || feature.dataset.saFeatureReady === 'true') return;
      feature.dataset.saFeatureReady = 'true';
      if (feature.dataset.saFeatureExpand === 'true') {
        saProductFeatureState.items.push(feature);
      }
    });

    if (saProductFeatureState.items.length) {
      saProductFeatureBindScroll();
    }
    saProductFeatureUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaProductFeature(document);
    });
  } else {
    initSaProductFeature(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaProductFeature(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    saProductFeatureOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-gallery"] && !Shopify.designMode) return;
  try {
    
  function syncSaProductGallery(root, swiperInstance) {
    if (!root) return;
    const bullets = Array.from(root.querySelectorAll('[data-product-gallery-bullet]'));
    if (!bullets.length) return;
    const index = swiperInstance && typeof swiperInstance.realIndex === 'number' ? swiperInstance.realIndex : 0;
    bullets.forEach(function (bullet, i) {
      const active = i === index;
      bullet.classList.toggle('is-active', active);
      bullet.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function initSaProductGallery(root) {
    if (!root || root.dataset.productGalleryReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = root.querySelector('[data-product-gallery-swiper]');
    if (!swiperEl || swiperEl.swiper) {
      if (swiperEl && swiperEl.swiper) root.dataset.productGalleryReady = 'true';
      return;
    }

    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount === 0) return;

    root.dataset.productGalleryReady = 'true';

    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(Number(root.dataset.delay) || 5000, 1000);

    const swiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      grabCursor: slideCount > 1,
      watchOverflow: true,
      rewind: autoplay && slideCount > 1,
      allowTouchMove: slideCount > 1,
      speed: 500,
      spaceBetween: 16,
      autoplay:
        autoplay && slideCount > 1
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      breakpoints: {
        1000: {
          spaceBetween: 56,
        },
      },
      on: {
        init: function (swiperInstance) {
          syncSaProductGallery(root, swiperInstance);
        },
        slideChange: function (swiperInstance) {
          syncSaProductGallery(root, swiperInstance);
        },
      },
    });

    root.querySelectorAll('[data-product-gallery-bullet]').forEach(function (bullet, index) {
      bullet.addEventListener('click', function () {
        swiper.slideTo(index);
      });
    });

    root._saProductGallerySwiper = swiper;
  }

  function initSaProductGalleries(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-product-gallery')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-product-gallery'));
    sections.forEach(initSaProductGallery);
  }

  function whenSaProductGallerySwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaProductGallery() {
    whenSaProductGallerySwiperReady(function () {
      initSaProductGalleries();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaProductGallery);
  } else {
    bootSaProductGallery();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSaProductGallerySwiperReady(function () {
      initSaProductGalleries(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-product-gallery');
    if (!root || !root._saProductGallerySwiper) return;
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const index = slides.indexOf(slide);
    if (index >= 0) root._saProductGallerySwiper.slideTo(index);
    if (root._saProductGallerySwiper.autoplay) root._saProductGallerySwiper.autoplay.stop();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-highlights"] && !Shopify.designMode) return;
  try {
    
  function saProductHighlightsSync(root) {
    if (!root) return;
    const scroller = root.querySelector('[data-highlights-scroll]');
    const thumb = root.querySelector('[data-highlights-progress-thumb]');
    const bar = root.querySelector('[data-highlights-progress]');
    if (!scroller || !thumb || !bar) return;

    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const ratio = 0.32;
    const progress = max > 0 ? scroller.scrollLeft / max : 0;
    const locked = max <= 1;

    bar.hidden = locked;
    thumb.style.width = (locked ? 1 : ratio) * 100 + '%';
    thumb.style.transform = locked
      ? 'translateX(0)'
      : 'translateX(' + (progress * ((1 - ratio) / ratio) * 100) + '%)';
  }

  function saProductHighlightsInit(root) {
    if (!root || root.dataset.highlightsReady === 'true') return;
    const scroller = root.querySelector('[data-highlights-scroll]');
    if (!scroller) return;

    root.dataset.highlightsReady = 'true';
    const onSync = function () {
      saProductHighlightsSync(root);
    };

    scroller.addEventListener('scroll', onSync, { passive: true });
    window.addEventListener('resize', onSync);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onSync).observe(scroller);
    }
    onSync();
  }

  document.querySelectorAll('.sa-product-highlights').forEach(saProductHighlightsInit);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.sa-product-highlights') || event.target.closest('.sa-product-highlights');
    if (!root) return;
    delete root.dataset.highlightsReady;
    saProductHighlightsInit(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-related"] && !Shopify.designMode) return;
  try {
    
  function saProductRelatedSwiper(root) {
    const el = root && root.querySelector('[data-related-swiper]');
    return el && el.swiper ? el.swiper : null;
  }

  function syncSaProductRelatedNav(root, swiper) {
    if (!root) return;
    const instance = swiper || saProductRelatedSwiper(root);
    if (!instance) return;

    const prevBtn = root.querySelector('[data-related-prev]');
    const nextBtn = root.querySelector('[data-related-next]');
    const thumb = root.querySelector('[data-related-progress-thumb]');
    const bar = root.querySelector('[data-related-progress]');
    const locked = instance.isLocked || (typeof instance.params.slidesPerView === 'number' && instance.slides.length <= instance.params.slidesPerView);

    if (thumb) {
      const view = instance.size || 1;
      const total = instance.virtualSize || view;
      const ratio = Math.min(1, view / total);
      const progress = typeof instance.progress === 'number' ? Math.min(1, Math.max(0, instance.progress)) : 0;
      const travel = Math.max(0, 1 - ratio);
      thumb.style.width = (locked ? 1 : ratio) * 100 + '%';
      thumb.style.transform = locked || travel === 0 || ratio === 0
        ? 'translateX(0)'
        : 'translateX(' + ((progress * travel) / ratio) * 100 + '%)';
    }
    if (bar) bar.hidden = locked;

    if (prevBtn) {
      const disabled = locked || instance.isBeginning;
      prevBtn.classList.toggle('is-disabled', disabled);
      prevBtn.disabled = disabled;
      prevBtn.hidden = locked;
    }
    if (nextBtn) {
      const disabled = locked || instance.isEnd;
      nextBtn.classList.toggle('is-disabled', disabled);
      nextBtn.disabled = disabled;
      nextBtn.hidden = locked;
    }
  }

  function refreshSaProductRelatedSwiper(swiper) {
    if (!swiper) return;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (typeof swiper.setTranslate === 'function') {
      swiper.setTranslate(swiper.getTranslate());
    }
  }

  function saProductRelatedSwiperOptions(root) {
    return {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      grabCursor: true,
      allowTouchMove: true,
      preventClicks: false,
      preventClicksPropagation: false,
      noSwiping: true,
      noSwipingSelector: 'button, a, [data-sa-card-swatch], .sa-product-card__overlay',
      speed: 500,
      spaceBetween: 8,
      breakpoints: {
        1000: {
          slidesPerView: 3,
          spaceBetween: 8,
        },
        1300: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
      },
      on: {
        init: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        progress: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        slideChange: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        fromEdge: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        reachBeginning: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        reachEnd: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
        breakpoint: function (swiperInstance) {
          refreshSaProductRelatedSwiper(swiperInstance);
          syncSaProductRelatedNav(root, swiperInstance);
        },
        resize: function (swiperInstance) {
          syncSaProductRelatedNav(root, swiperInstance);
        },
      },
    };
  }

  function ensureSaProductRelatedSwiper(root) {
    const swiperEl = root.querySelector('[data-related-swiper]');
    if (!swiperEl) return null;
    if (swiperEl.swiper) return swiperEl.swiper;
    return new Swiper(swiperEl, saProductRelatedSwiperOptions(root));
  }

  function bindSaProductRelatedResize(root) {
    if (root._saRelatedRo || typeof ResizeObserver === 'undefined') return;
    const stage = root.querySelector('.sa-product-related__stage');
    if (!stage) return;

    var raf = 0;
    root._saRelatedRo = new ResizeObserver(function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        const swiper = saProductRelatedSwiper(root);
        refreshSaProductRelatedSwiper(swiper);
        syncSaProductRelatedNav(root, swiper);
      });
    });
    root._saRelatedRo.observe(stage);
  }

  function initSaProductRelated(root) {
    if (!root || typeof Swiper === 'undefined') return;
    const swiperEl = root.querySelector('[data-related-swiper]');
    if (!swiperEl) return;

    ensureSaProductRelatedSwiper(root);
    bindSaProductRelatedResize(root);

    if (root.dataset.relatedBound === 'true') return;
    root.dataset.relatedBound = 'true';

    const prevBtn = root.querySelector('[data-related-prev]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        const swiper = saProductRelatedSwiper(root);
        if (swiper && !swiper.isBeginning) swiper.slidePrev();
      });
    }

    const nextBtn = root.querySelector('[data-related-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const swiper = saProductRelatedSwiper(root);
        if (swiper && !swiper.isEnd) swiper.slideNext();
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const swiper = saProductRelatedSwiper(root);
        refreshSaProductRelatedSwiper(swiper);
        syncSaProductRelatedNav(root, swiper);
      });
    });
  }

  function initSaProductRelatedSections(scope) {
    const root = scope || document;
    const sections =
      root.matches && root.matches('[data-sa-product-related]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-sa-product-related]'));
    sections.forEach(initSaProductRelated);
  }

  function whenSaProductRelatedSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaProductRelated() {
    whenSaProductRelatedSwiperReady(function () {
      initSaProductRelatedSections();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaProductRelated);
  } else {
    bootSaProductRelated();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-sa-product-related]').forEach(function (root) {
      const swiper = saProductRelatedSwiper(root);
      refreshSaProductRelatedSwiper(swiper);
      syncSaProductRelatedNav(root, swiper);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    whenSaProductRelatedSwiperReady(function () {
      initSaProductRelatedSections(event.target);
    });
  });

  document.addEventListener('recommendations:loaded', function () {
    whenSaProductRelatedSwiperReady(function () {
      document.querySelectorAll('[data-sa-product-related]').forEach(function (root) {
        root.dataset.relatedBound = 'false';
        if (root._saRelatedRo) {
          root._saRelatedRo.disconnect();
          root._saRelatedRo = null;
        }
        initSaProductRelated(root);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  function initSaProductSpotlight(root) {
    if (!root || root.dataset.spotlightReady === 'true') return;
    root.dataset.spotlightReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-spotlight-card]'));
    const bgs = Array.from(root.querySelectorAll('[data-spotlight-bg]'));
    const scroller = root.querySelector('[data-spotlight-scroller]');
    const surface = root.querySelector('[data-spotlight-surface]');
    const dots = Array.from(root.querySelectorAll('[data-spotlight-dot]'));
    const mq = window.matchMedia('(min-width: 1000px)');
    let activeIndex = 0;
    let scrollRaf = 0;

    function setActive(index) {
      if (index < 0 || index >= cards.length) return;
      activeIndex = index;
      cards.forEach(function (card, i) {
        const on = i === index;
        card.classList.toggle('is-active', on);
        const toggle = card.querySelector('[data-spotlight-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
          toggle.tabIndex = on ? -1 : 0;
        }
      });
      bgs.forEach(function (bg, i) {
        bg.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function currentScrollIndex() {
      if (!scroller || !cards.length) return 0;
      const scrollerRect = scroller.getBoundingClientRect();
      const styles = window.getComputedStyle(scroller);
      const pad = parseFloat(styles.paddingLeft) || 0;
      const origin = scrollerRect.left + pad;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach(function (card, i) {
        const dist = Math.abs(card.getBoundingClientRect().left - origin);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function syncFromScroll() {
      if (mq.matches) return;
      setActive(currentScrollIndex());
    }

    function onScrollerScroll() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        syncFromScroll();
      });
    }

    function scrollToCard(index) {
      const card = cards[index];
      if (!scroller || !card || !cards[0]) return;
      scroller.scrollTo({
        left: card.offsetLeft - cards[0].offsetLeft,
        behavior: 'smooth',
      });
    }

    function goTo(index) {
      setActive(index);
      if (!mq.matches) scrollToCard(index);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('a')) return;
        goTo(i);
      });
    });

    if (scroller) {
      scroller.addEventListener('scroll', onScrollerScroll, { passive: true });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (surface) {
      let touchX = 0;
      let touchY = 0;
      let touching = false;

      surface.addEventListener(
        'touchstart',
        function (event) {
          if (mq.matches || event.target.closest('a, button')) return;
          const touch = event.changedTouches[0];
          if (!touch) return;
          touchX = touch.clientX;
          touchY = touch.clientY;
          touching = true;
        },
        { passive: true }
      );

      surface.addEventListener(
        'touchend',
        function (event) {
          if (!touching || mq.matches) return;
          touching = false;
          if (event.target.closest('[data-spotlight-scroller]')) return;
          const touch = event.changedTouches[0];
          if (!touch) return;
          const dx = touch.clientX - touchX;
          const dy = touch.clientY - touchY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          goTo(dx < 0 ? Math.min(cards.length - 1, activeIndex + 1) : Math.max(0, activeIndex - 1));
        },
        { passive: true }
      );
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', function (event) {
        if (event.matches && scroller) scroller.scrollLeft = 0;
      });
    }

    root._saSpotlightSetActive = setActive;
    root._saSpotlightScrollTo = scrollToCard;
  }

  function initSaProductSpotlights(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-product-spotlight')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-product-spotlight'));
    sections.forEach(initSaProductSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaProductSpotlights();
    });
  } else {
    initSaProductSpotlights();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaProductSpotlights(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const card = event.target.closest('[data-spotlight-card]');
    const root = event.target.closest('.sa-product-spotlight');
    if (!card || !root) return;
    const cards = Array.from(root.querySelectorAll('[data-spotlight-card]'));
    const index = cards.indexOf(card);
    if (index < 0) return;
    if (typeof root._saSpotlightSetActive === 'function') {
      root._saSpotlightSetActive(index);
    }
    if (window.matchMedia('(max-width: 999px)').matches && typeof root._saSpotlightScrollTo === 'function') {
      root._saSpotlightScrollTo(index);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-quality-heritage"] && !Shopify.designMode) return;
  try {
    
  function saQualityHeritageSync(root) {
    if (!root) return;
    const scroller = root.querySelector('[data-heritage-scroll]');
    const thumb = root.querySelector('[data-heritage-progress-thumb]');
    const bar = root.querySelector('[data-heritage-progress]');
    if (!scroller || !thumb || !bar) return;

    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    const ratio = 0.32;
    const progress = max > 0 ? scroller.scrollLeft / max : 0;
    const locked = max <= 1;

    bar.hidden = locked;
    thumb.style.width = (locked ? 1 : ratio) * 100 + '%';
    thumb.style.transform = locked
      ? 'translateX(0)'
      : 'translateX(' + (progress * ((1 - ratio) / ratio) * 100) + '%)';
  }

  function saQualityHeritageInit(root) {
    if (!root || root.dataset.heritageReady === 'true') return;
    const scroller = root.querySelector('[data-heritage-scroll]');
    if (!scroller) return;

    root.dataset.heritageReady = 'true';
    const onSync = function () {
      saQualityHeritageSync(root);
    };

    scroller.addEventListener('scroll', onSync, { passive: true });
    window.addEventListener('resize', onSync);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onSync).observe(scroller);
    }
    onSync();
  }

  document.querySelectorAll('.sa-quality-heritage').forEach(saQualityHeritageInit);

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('.sa-quality-heritage') || event.target.closest('.sa-quality-heritage');
    if (!root) return;
    delete root.dataset.heritageReady;
    saQualityHeritageInit(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-quality-masterpiece"] && !Shopify.designMode) return;
  try {
    
  function saQualityMasterpieceVideo(root) {
    if (!root) return null;
    return root.querySelector('[data-masterpiece-dialog] video-intersection-insert');
  }

  function closeSaQualityMasterpieceDialog(root) {
    const dialog = root.querySelector('[data-masterpiece-dialog]');
    if (!dialog || !dialog.open) return;
    const video = saQualityMasterpieceVideo(root);
    if (video && typeof video.pauseMedia === 'function') video.pauseMedia();
    dialog.close();
  }

  function openSaQualityMasterpieceDialog(root) {
    const dialog = root.querySelector('[data-masterpiece-dialog]');
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    const video = saQualityMasterpieceVideo(root);
    if (video && typeof video.playMedia === 'function') video.playMedia();
  }

  function initSaQualityMasterpiece(root) {
    if (!root || root.dataset.saMasterpieceReady === 'true') return;
    root.dataset.saMasterpieceReady = 'true';

    const openBtn = root.querySelector('[data-masterpiece-open]');
    const closeBtn = root.querySelector('[data-masterpiece-close]');
    const dialog = root.querySelector('[data-masterpiece-dialog]');

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        openSaQualityMasterpieceDialog(root);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeSaQualityMasterpieceDialog(root);
      });
    }
    if (dialog) {
      dialog.addEventListener('close', function () {
        const video = saQualityMasterpieceVideo(root);
        if (video && typeof video.pauseMedia === 'function') video.pauseMedia();
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeSaQualityMasterpieceDialog(root);
      });
    }
  }

  function initSaQualityMasterpieces(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-quality-masterpiece')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-quality-masterpiece'));
    sections.forEach(initSaQualityMasterpiece);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaQualityMasterpieces(document);
    });
  } else {
    initSaQualityMasterpieces(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSaQualityMasterpieces(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-quality-materials"] && !Shopify.designMode) return;
  try {
    
  function saQualityMaterialsReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSaQualityMaterials(root) {
    if (!root || root.dataset.materialsReady === 'true') return;
    root.dataset.materialsReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-materials-card]'));
    const bgs = Array.from(root.querySelectorAll('[data-materials-bg]'));
    const wrap = root.querySelector('[data-materials-cards]');
    const layers = Array.from(root.querySelectorAll('[data-materials-layer]'));
    const scroller = root.querySelector('[data-materials-scroller]');
    const viewport = root.querySelector('[data-materials-viewport]');
    const titleEl = root.querySelector('[data-materials-title]');
    const desktopMq = window.matchMedia('(min-width: 1000px)');
    let activeIndex = 0;
    let coverToken = 0;

    function measureTitle() {
      if (!titleEl || desktopMq.matches) return;
      root.style.setProperty('--materials-title-h', titleEl.offsetHeight + 'px');
    }

    function setMobileLayers(progress) {
      if (!layers.length) return;
      const last = layers.length - 1;
      const clamped = Math.min(Math.max(progress, 0), last);
      const index = Math.min(Math.floor(clamped), last);
      const frac = clamped - index;
      activeIndex = index;
      layers.forEach(function (layer, i) {
        let y = 100;
        if (i <= index) y = 0;
        else if (i === index + 1) y = (1 - frac) * 100;
        layer.style.transform = 'translate3d(0,' + y + '%,0)';
      });
    }

    function updateMobileCover() {
      if (desktopMq.matches || !scroller || !viewport || !layers.length) return;
      const vh = viewport.offsetHeight || window.innerHeight || 1;
      const maxScroll = Math.max(scroller.offsetHeight - vh, 0);
      const scrolled = Math.min(Math.max(-scroller.getBoundingClientRect().top, 0), maxScroll);
      let progress = scrolled / vh;
      if (saQualityMaterialsReduced()) progress = Math.round(progress);
      setMobileLayers(progress);
    }

    function setColumns(index) {
      if (!wrap) return;
      if (!window.matchMedia('(min-width: 1000px)').matches || cards.length < 2) {
        wrap.style.removeProperty('grid-template-columns');
        return;
      }
      const activeFr = window.matchMedia('(min-width: 1560px)').matches ? '3.6fr' : '2.4fr';
      wrap.style.gridTemplateColumns = cards
        .map(function (_, i) {
          return i === index ? activeFr : '1fr';
        })
        .join(' ');
    }

    function setCardState(index) {
      cards.forEach(function (card, i) {
        const on = i === index;
        card.classList.toggle('is-active', on);
        card.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      setColumns(index);
    }

    function finishCover(token, incoming, outgoing) {
      if (token !== coverToken) return;
      incoming.classList.remove('is-incoming', 'is-from-end', 'is-from-start');
      if (outgoing && outgoing !== incoming) outgoing.classList.remove('is-active');
      bgs.forEach(function (bg, i) {
        if (i !== activeIndex) bg.classList.remove('is-active', 'is-incoming', 'is-from-end', 'is-from-start');
      });
    }

    function coverTo(index) {
      if (index < 0 || index >= cards.length || index === activeIndex) return;
      const prev = activeIndex;
      const incoming = bgs[index];
      const outgoing = bgs[prev];
      const forward = index > prev;
      activeIndex = index;
      setCardState(index);

      if (!incoming || bgs.length < 2) return;

      coverToken += 1;
      const token = coverToken;
      bgs.forEach(function (bg) {
        bg.classList.remove('is-incoming', 'is-from-end', 'is-from-start');
      });

      if (saQualityMaterialsReduced()) {
        incoming.classList.add('is-active');
        if (outgoing) outgoing.classList.remove('is-active');
        return;
      }

      incoming.classList.remove('is-active');
      incoming.classList.add(forward ? 'is-from-end' : 'is-from-start');
      incoming.offsetWidth;
      incoming.classList.add('is-incoming', 'is-active');

      function onEnd(event) {
        if (event && event.propertyName && event.propertyName !== 'transform') return;
        incoming.removeEventListener('transitionend', onEnd);
        finishCover(token, incoming, outgoing);
      }

      incoming.addEventListener('transitionend', onEnd);
      window.setTimeout(function () {
        incoming.removeEventListener('transitionend', onEnd);
        finishCover(token, incoming, outgoing);
      }, 800);
    }

    function goTo(index) {
      if (desktopMq.matches) {
        coverTo(index);
        return;
      }
      if (!scroller || !viewport || index < 0 || index >= layers.length) return;
      const vh = viewport.offsetHeight || window.innerHeight;
      const y = scroller.getBoundingClientRect().top + window.scrollY + index * vh;
      window.scrollTo({ top: y, behavior: saQualityMaterialsReduced() ? 'auto' : 'smooth' });
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        coverTo(i);
      });
    });

    setColumns(0);
    measureTitle();
    updateMobileCover();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureTitle();
        updateMobileCover();
      });
    }

    if (root._saMaterialsOnScroll) {
      window.removeEventListener('scroll', root._saMaterialsOnScroll);
    }
    if (root._saMaterialsOnResize) {
      window.removeEventListener('resize', root._saMaterialsOnResize);
    }
    root._saMaterialsOnScroll = updateMobileCover;
    root._saMaterialsOnResize = function () {
      measureTitle();
      setColumns(activeIndex);
      updateMobileCover();
    };
    window.addEventListener('scroll', root._saMaterialsOnScroll, { passive: true });
    window.addEventListener('resize', root._saMaterialsOnResize);

    root._saMaterialsGoTo = goTo;
  }

  function initSaQualityMaterialsAll(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-quality-materials')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-quality-materials'));
    sections.forEach(initSaQualityMaterials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSaQualityMaterialsAll(document);
    });
  } else {
    initSaQualityMaterialsAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root =
      event.target.querySelector('.sa-quality-materials') ||
      event.target.closest('.sa-quality-materials');
    if (!root) return;
    delete root.dataset.materialsReady;
    initSaQualityMaterials(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-quality-materials');
    if (!root || typeof root._saMaterialsGoTo !== 'function') return;
    const card = event.target.closest('[data-materials-card]');
    const layer = event.target.closest('[data-materials-layer]');
    const cards = Array.from(root.querySelectorAll('[data-materials-card]'));
    const layers = Array.from(root.querySelectorAll('[data-materials-layer]'));
    let index = -1;
    if (card) index = cards.indexOf(card);
    else if (layer) index = layers.indexOf(layer);
    if (index >= 0) root._saMaterialsGoTo(index);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-stores"] && !Shopify.designMode) return;
  try {
    
  function whenSaStoresSwiperReady(cb) {
    if (typeof Swiper === 'function') {
      cb();
      return;
    }
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (typeof Swiper === 'function' || n > 40) {
        clearInterval(t);
        if (typeof Swiper === 'function') cb();
      }
    }, 50);
  }

  function initSaStores(root) {
    if (!root || root.dataset.saStoresReady === 'true') return;
    root.dataset.saStoresReady = 'true';

    var swiperEl = root.querySelector('[data-stores-swiper]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sa-stores__slide'));
    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-store-pin]'));
    var dialog = root.querySelector('[data-stores-dialog]');
    var prevBtn = root.querySelector('[data-stores-prev]');
    var nextBtn = root.querySelector('[data-stores-next]');
    var mapEl = root.querySelector('[data-stores-map]');
    var wrapper = swiperEl ? swiperEl.querySelector('.swiper-wrapper') : null;
    var mq = window.matchMedia('(min-width: 1000px)');
    var swiper = null;
    var activeIndex = 0;
    var compactW = 192;
    var expandedW = 614;
    var slideGap = 48;
    var zoomInBtn = root.querySelector('[data-map-zoom-in]');
    var zoomOutBtn = root.querySelector('[data-map-zoom-out]');
    var mapMinScale = 1;
    var mapMaxScale = 3.2;
    var mapZoomStep = 0.35;
    var currentScale = 1;
    var panX = 0;
    var panY = 0;
    var panStartX = 0;
    var panStartY = 0;
    var dragStartX = 0;
    var dragStartY = 0;
    var mapDragging = false;
    var mapDidPan = false;

    function syncPins(index) {
      pins.forEach(function (pin) {
        var active = Number(pin.dataset.storeIndex) === index;
        pin.classList.toggle('is-active', active);
        pin.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateNav(index) {
      if (prevBtn) prevBtn.classList.toggle('is-disabled', index <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', index >= slides.length - 1);
    }

    function updateTrack(animate) {
      if (!wrapper) return;
      if (!mq.matches) {
        wrapper.style.removeProperty('--stores-track-x');
        return;
      }
      var containerW = swiperEl.clientWidth;
      var before = activeIndex * (compactW + slideGap);
      var offset = Math.round(containerW / 2 - before - expandedW / 2);
      if (animate === false) wrapper.style.transition = 'none';
      wrapper.style.setProperty('--stores-track-x', offset + 'px');
      if (animate === false) {
        void wrapper.offsetWidth;
        wrapper.style.transition = '';
      }
    }

    function defaultMapScale() {
      return 1;
    }

    function applyMapTransform() {
      if (!mapEl) return;
      mapEl.style.setProperty('--map-scale', String(currentScale));
      mapEl.style.setProperty('--map-pan-x', panX + 'px');
      mapEl.style.setProperty('--map-pan-y', panY + 'px');
    }

    function clampMapPan() {
      if (!mapEl) return;
      var w = mapEl.clientWidth || 1;
      var h = mapEl.clientHeight || 1;
      var s = currentScale;
      panX = Math.min(0, Math.max(w * (1 - s), panX));
      panY = Math.min(0, Math.max(h * (1 - s), panY));
    }

    function updateZoomButtons() {
      if (zoomInBtn) zoomInBtn.classList.toggle('is-disabled', currentScale >= mapMaxScale - 0.001);
      if (zoomOutBtn) zoomOutBtn.classList.toggle('is-disabled', currentScale <= mapMinScale + 0.001);
    }

    function pinLocalPos(index) {
      var art = mapEl.querySelector('.sa-stores__map-art');
      var mw = mapEl.clientWidth || 1;
      var mh = mapEl.clientHeight || 1;
      var aw = art ? art.offsetWidth : mw;
      var ah = art ? art.offsetHeight : mh;
      var pin = pins[index];
      var x = pin ? parseFloat(pin.style.left) : 50;
      var y = pin ? parseFloat(pin.style.top) : 50;
      if (Number.isNaN(x)) x = 50;
      if (Number.isNaN(y)) y = 50;
      return {
        x: (mw - aw) / 2 + (x / 100) * aw,
        y: (mh - ah) / 2 + (y / 100) * ah
      };
    }

    function updateMapFocus() {
      if (!mapEl) return;
      var w = mapEl.clientWidth || 1;
      var h = mapEl.clientHeight || 1;
      var pos = pinLocalPos(activeIndex);
      panX = w / 2 - pos.x * currentScale;
      panY = h * 0.42 - pos.y * currentScale;
      clampMapPan();
      applyMapTransform();
      updateZoomButtons();
    }

    function zoomMap(delta) {
      if (!mapEl) return;
      var w = mapEl.clientWidth || 1;
      var h = mapEl.clientHeight || 1;
      var next = Math.min(mapMaxScale, Math.max(mapMinScale, Math.round((currentScale + delta) * 100) / 100));
      if (next === currentScale) return;
      var lx = (w / 2 - panX) / currentScale;
      var ly = (h / 2 - panY) / currentScale;
      currentScale = next;
      panX = w / 2 - lx * currentScale;
      panY = h / 2 - ly * currentScale;
      clampMapPan();
      applyMapTransform();
      updateZoomButtons();
    }

    function setActive(index, fromSwiper) {
      if (Number.isNaN(index) || index < 0 || index >= slides.length) return;
      activeIndex = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      syncPins(index);
      updateNav(index);
      updateTrack();
      updateMapFocus();
      if (!fromSwiper && swiper && !mq.matches) swiper.slideTo(index);
    }

    function destroySwiper() {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = null;
      root._saStoresSwiper = null;
    }

    function createSwiper() {
      if (swiper || !swiperEl || typeof Swiper !== 'function') return;
      swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        speed: 400,
        slideToClickedSlide: true,
        watchOverflow: true,
        on: {
          init: function (sw) {
            setActive(sw.realIndex, true);
          },
          slideChange: function (sw) {
            setActive(sw.realIndex, true);
          }
        }
      });
      root._saStoresSwiper = swiper;
      swiper.slideTo(activeIndex, 0);
    }

    function syncMode() {
      if (mq.matches) {
        destroySwiper();
        updateTrack(false);
      } else {
        whenSaStoresSwiperReady(createSwiper);
        updateTrack(false);
      }
      updateMapFocus();
    }

    function goToStore(index) {
      setActive(index);
    }

    function closeDialog() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    function openDialog(slide) {
      if (!dialog || !slide) return;

      var titleEl = dialog.querySelector('[data-dialog-title]');
      var locationEl = dialog.querySelector('[data-dialog-location]');
      var phoneEl = dialog.querySelector('[data-dialog-phone]');
      var hoursEl = dialog.querySelector('[data-dialog-hours]');
      var hoursBlock = dialog.querySelector('[data-dialog-hours-block]');
      var imageEl = dialog.querySelector('[data-dialog-image]');
      var mediaWrap = dialog.querySelector('.sa-stores__dialog-media');
      var hoursNode = slide.querySelector('[data-store-hours]');
      var cardImg = slide.querySelector('img');
      var phone = slide.dataset.storePhone || '';
      var hours = hoursNode ? hoursNode.textContent.trim() : '';

      if (titleEl) titleEl.textContent = slide.dataset.storeName || '';
      if (locationEl) locationEl.textContent = slide.dataset.storeLocation || '';
      if (phoneEl) phoneEl.textContent = phone ? 'Tel: ' + phone : '';
      if (hoursEl) hoursEl.textContent = hours;
      if (hoursBlock) hoursBlock.hidden = !hours;

      var src = cardImg ? cardImg.currentSrc || cardImg.src : '';
      if (imageEl && src) {
        imageEl.src = src;
        imageEl.alt = slide.dataset.storeName || '';
        if (mediaWrap) mediaWrap.classList.add('has-image');
      } else if (mediaWrap) {
        mediaWrap.classList.remove('has-image');
      }

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    whenSaStoresSwiperReady(function () {
      syncMode();
    });
    if (mq.matches) syncMode();
    if (mq.addEventListener) mq.addEventListener('change', syncMode);
    else mq.addListener(syncMode);
    root._saStoresMq = mq;
    root._saStoresOnMq = syncMode;

    updateNav(activeIndex);
    currentScale = defaultMapScale();
    updateTrack(false);
    updateMapFocus();

    if (typeof ResizeObserver === 'function' && swiperEl) {
      var ro = new ResizeObserver(function () {
        if (mq.matches) updateTrack(false);
      });
      ro.observe(swiperEl);
      root._saStoresRo = ro;
    } else {
      var onResize = function () {
        if (mq.matches) updateTrack(false);
      };
      window.addEventListener('resize', onResize);
      root._saStoresOnResize = onResize;
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (mq.matches) goToStore(i);
      });
    });

    pins.forEach(function (pin) {
      pin.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mapDidPan) return;
        goToStore(Number(pin.dataset.storeIndex));
      });
    });

    if (mapEl) {
      mapEl.addEventListener('pointerdown', function (event) {
        if (event.button != null && event.button !== 0) return;
        if (event.target.closest('[data-store-pin], [data-stores-zoom]')) return;
        mapDragging = true;
        mapDidPan = false;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        panStartX = panX;
        panStartY = panY;
      });

      mapEl.addEventListener('pointermove', function (event) {
        if (!mapDragging) return;
        var dx = event.clientX - dragStartX;
        var dy = event.clientY - dragStartY;
        if (!mapDidPan && dx * dx + dy * dy < 64) return;
        if (!mapDidPan) {
          mapDidPan = true;
          mapEl.classList.add('is-panning');
          try {
            mapEl.setPointerCapture(event.pointerId);
          } catch (err) {}
        }
        panX = panStartX + dx;
        panY = panStartY + dy;
        clampMapPan();
        applyMapTransform();
      });

      function endMapPan(event) {
        if (!mapDragging) return;
        mapDragging = false;
        mapEl.classList.remove('is-panning');
        try {
          mapEl.releasePointerCapture(event.pointerId);
        } catch (err) {}
        if (mapDidPan) {
          window.setTimeout(function () {
            mapDidPan = false;
          }, 0);
        }
      }

      mapEl.addEventListener('pointerup', endMapPan);
      mapEl.addEventListener('pointercancel', endMapPan);
    }

    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        zoomMap(mapZoomStep);
      });
    }

    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        zoomMap(-mapZoomStep);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToStore(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToStore(activeIndex + 1);
      });
    }

    root.querySelectorAll('[data-store-learn-more]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var slide = btn.closest('.sa-stores__slide');
        openDialog(slide);
      });
    });

    if (dialog) {
      var closeBtn = dialog.querySelector('[data-stores-dialog-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
    }
  }

  document.querySelectorAll('[data-sa-stores]').forEach(initSaStores);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sa-stores]');
    if (root) initSaStores(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-sa-stores]');
    if (!root) return;
    if (root._saStoresOnMq && root._saStoresMq) {
      if (root._saStoresMq.removeEventListener) {
        root._saStoresMq.removeEventListener('change', root._saStoresOnMq);
      } else {
        root._saStoresMq.removeListener(root._saStoresOnMq);
      }
    }
    if (root._saStoresRo) {
      root._saStoresRo.disconnect();
      root._saStoresRo = null;
    }
    if (root._saStoresOnResize) {
      window.removeEventListener('resize', root._saStoresOnResize);
      root._saStoresOnResize = null;
    }
    if (root._saStoresSwiper) {
      root._saStoresSwiper.destroy(true, true);
      root._saStoresSwiper = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-story-spotlight"] && !Shopify.designMode) return;
  try {
    
  function syncSaStorySpotlight(root, index, scrollTab) {
    if (!root) return;
    const tabs = Array.from(root.querySelectorAll('[data-story-tab]'));
    const tabsEl = root.querySelector('[data-story-tabs]');
    const medias = Array.from(root.querySelectorAll('[data-story-media]'));
    const ctas = Array.from(root.querySelectorAll('[data-story-cta]'));
    const counterCurrent = root.querySelector('[data-story-counter-current]');

    tabs.forEach(function (tab, i) {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scrollTab && tabsEl) {
        const target = tab.offsetLeft - (tabsEl.clientWidth - tab.offsetWidth) / 2;
        tabsEl.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    });

    if (medias.length > 1) {
      medias.forEach(function (media, i) {
        media.classList.toggle('is-active', i === index);
      });
    }

    ctas.forEach(function (cta, i) {
      cta.classList.toggle('is-active', i === index);
    });

    if (counterCurrent) {
      counterCurrent.textContent = String(index + 1);
    }
  }

  function saStoryDesktopMq() {
    return window.matchMedia('(min-width: 1000px)');
  }

  function createSaStorySwiper(root, swiperEl) {
    if (typeof Swiper === 'undefined' || !swiperEl || swiperEl.swiper) return;

    const tabs = Array.from(root.querySelectorAll('[data-story-tab]'));
    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    const nextEl = root.querySelector('.swiper-button-next');
    const prevEl = root.querySelector('.swiper-button-prev');
    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(Number(root.dataset.delay) || 5000, 1000);
    const options = {
      observer: true,
      observeParents: true,
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      watchOverflow: true,
      rewind: autoplay && slideCount > 1,
      allowTouchMove: slideCount > 1,
      autoplay:
        autoplay && slideCount > 1
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      on: {
        init: function (swiperInstance) {
          syncSaStorySpotlight(root, swiperInstance.realIndex, false);
        },
        slideChange: function (swiperInstance) {
          syncSaStorySpotlight(root, swiperInstance.realIndex, true);
        },
      },
    };

    if (nextEl && prevEl) {
      options.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    const swiper = new Swiper(swiperEl, options);

    if (root.dataset.storyTabsBound !== 'true') {
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          if (root._saStorySwiper) root._saStorySwiper.slideTo(i);
        });
      });
      root.dataset.storyTabsBound = 'true';
    }

    root._saStorySwiper = swiper;
  }

  function destroySaStorySwiper(root, swiperEl) {
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
    root._saStorySwiper = null;
  }

  function syncSaStoryMode(root) {
    const swiperEl = root.querySelector('[data-story-swiper]');
    if (!swiperEl) return;
    if (saStoryDesktopMq().matches) {
      createSaStorySwiper(root, swiperEl);
    } else {
      destroySaStorySwiper(root, swiperEl);
    }
  }

  function initSaStorySpotlight(root) {
    if (!root) return;

    const swiperEl = root.querySelector('[data-story-swiper]');
    if (!swiperEl) return;

    if (root.dataset.storyReady !== 'true') {
      root.dataset.storyReady = 'true';
      saStoryDesktopMq().addEventListener('change', function () {
        syncSaStoryMode(root);
      });
    }

    if (saStoryDesktopMq().matches) {
      if (typeof Swiper === 'undefined') return;
      createSaStorySwiper(root, swiperEl);
    } else {
      destroySaStorySwiper(root, swiperEl);
    }
  }

  function initSaStorySpotlights(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-story-spotlight')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-story-spotlight'));
    sections.forEach(initSaStorySpotlight);
  }

  function whenSaStorySwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaStorySpotlights() {
    whenSaStorySwiperReady(function () {
      initSaStorySpotlights();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaStorySpotlights);
  } else {
    bootSaStorySpotlights();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSaStorySwiperReady(function () {
      initSaStorySpotlights(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-story-spotlight');
    if (!root) return;
    const slide = event.target.closest('.swiper-slide');
    const tab = event.target.closest('[data-story-tab]');
    let index = -1;
    if (slide) {
      const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      index = slides.indexOf(slide);
    } else if (tab) {
      const tabs = Array.from(root.querySelectorAll('[data-story-tab]'));
      index = tabs.indexOf(tab);
    }
    if (index < 0) return;
    if (root._saStorySwiper) {
      root._saStorySwiper.slideTo(index);
      if (root._saStorySwiper.autoplay) root._saStorySwiper.autoplay.stop();
      return;
    }
    const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const target = slides[index];
    if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-sustainability-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openPanel(item) {
      if (!item || item.classList.contains('is-open')) return;
      var row = item.closest('.sa-sustainability-panels__row');
      if (!row) return;
      row.querySelectorAll('.sa-sustainability-panels__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      item.classList.add('is-open');
    }

    function bind(root) {
      if (!root || root.dataset.susBound === 'true') return;
      root.dataset.susBound = 'true';

      var row = root.querySelector('.sa-sustainability-panels__row');
      if (!row) return;

      row.querySelectorAll('.sa-sustainability-panels__item').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          openPanel(item);
        });
        item.addEventListener('focusin', function () {
          openPanel(item);
        });
      });
    }

    function boot(scope) {
      var context = scope || document;
      context.querySelectorAll('.sa-sustainability-panels').forEach(bind);
    }

    boot();

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.sa-sustainability-panels');
      if (!root) return;
      delete root.dataset.susBound;
      bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initSaTestimonials(root) {
    if (!root || root.dataset.testimonialsReady === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const swiperEl = root.querySelector('[data-testimonials-swiper]');
    if (!swiperEl || swiperEl.swiper) {
      if (swiperEl && swiperEl.swiper) root.dataset.testimonialsReady = 'true';
      return;
    }

    const slideCount = root.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount === 0) return;

    root.dataset.testimonialsReady = 'true';

    const autoplay = root.dataset.autoplay === 'true';
    const delay = Math.max(Number(root.dataset.delay) || 5000, 1000);

    const swiper = new Swiper(swiperEl, {
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      grabCursor: slideCount > 1,
      watchOverflow: true,
      rewind: autoplay && slideCount > 1,
      allowTouchMove: slideCount > 1,
      speed: 500,
      spaceBetween: 16,
     
      autoplay:
        autoplay && slideCount > 1
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
      breakpoints: {
        1000: {
          spaceBetween: 64,
        },
        1560: {
          spaceBetween: 64,
        },
      },
    });

    root._saTestimonialsSwiper = swiper;
  }

  function initSaTestimonialsSections(scope) {
    const root = scope || document;
    const sections =
      root.classList && root.classList.contains('sa-testimonials')
        ? [root]
        : Array.from(root.querySelectorAll('.sa-testimonials'));
    sections.forEach(initSaTestimonials);
  }

  function whenSaTestimonialsSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function bootSaTestimonials() {
    whenSaTestimonialsSwiperReady(function () {
      initSaTestimonialsSections();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSaTestimonials);
  } else {
    bootSaTestimonials();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSaTestimonialsSwiperReady(function () {
      initSaTestimonialsSections(event.target);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    const root = event.target.closest('.sa-testimonials');
    if (!root || !root._saTestimonialsSwiper) return;
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    const slides = Array.from(root.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const index = slides.indexOf(slide);
    if (index >= 0) root._saTestimonialsSwiper.slideTo(index);
    if (root._saTestimonialsSwiper.autoplay) root._saTestimonialsSwiper.autoplay.stop();
  });

  } catch(e) { console.error(e); }
})();
})();
